(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire041c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire041c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7ayQm", function(module, exports) {

$parcel$export(module.exports, "register", () => $53847ecab4bbea52$export$6503ec6e8aabbaf, (v) => $53847ecab4bbea52$export$6503ec6e8aabbaf = v);
var $53847ecab4bbea52$export$6503ec6e8aabbaf;
var $53847ecab4bbea52$export$f7ad0328861e2f03;
"use strict";
var $53847ecab4bbea52$var$mapping = new Map();
function $53847ecab4bbea52$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$53847ecab4bbea52$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $53847ecab4bbea52$var$resolve(id) {
    var resolved = $53847ecab4bbea52$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$53847ecab4bbea52$export$6503ec6e8aabbaf = $53847ecab4bbea52$var$register;
$53847ecab4bbea52$export$f7ad0328861e2f03 = $53847ecab4bbea52$var$resolve;

});

parcelRegister("lIGhs", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $fcfe81162e3681fe$export$bdfd709ae4826697, (v) => $fcfe81162e3681fe$export$bdfd709ae4826697 = v);
var $fcfe81162e3681fe$export$bdfd709ae4826697;
var $fcfe81162e3681fe$export$c9e73fbda7da57b6;
var $fcfe81162e3681fe$export$5a759dc7a1cfb72a;
"use strict";
var $fcfe81162e3681fe$var$bundleURL = {};
function $fcfe81162e3681fe$var$getBundleURLCached(id) {
    var value = $fcfe81162e3681fe$var$bundleURL[id];
    if (!value) {
        value = $fcfe81162e3681fe$var$getBundleURL();
        $fcfe81162e3681fe$var$bundleURL[id] = value;
    }
    return value;
}
function $fcfe81162e3681fe$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $fcfe81162e3681fe$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $fcfe81162e3681fe$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $fcfe81162e3681fe$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$fcfe81162e3681fe$export$bdfd709ae4826697 = $fcfe81162e3681fe$var$getBundleURLCached;
$fcfe81162e3681fe$export$c9e73fbda7da57b6 = $fcfe81162e3681fe$var$getBaseURL;
$fcfe81162e3681fe$export$5a759dc7a1cfb72a = $fcfe81162e3681fe$var$getOrigin;

});

parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
"use strict";

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
"use strict";

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $dd934af551f44020$export$3ba232387fd5d6dd, (v) => $dd934af551f44020$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$3ba232387fd5d6dd;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
"use strict";
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
function $dd934af551f44020$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$3ba232387fd5d6dd = $dd934af551f44020$var$X;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = $dd934af551f44020$var$X;
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$Lg(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$Lg(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$Sg(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Ug = $17f526922e4a857c$var$Og(!0), $17f526922e4a857c$var$Vg = $17f526922e4a857c$var$Og(!1), $17f526922e4a857c$var$Wg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Xg = null, $17f526922e4a857c$var$Yg = null, $17f526922e4a857c$var$Zg = null;
function $17f526922e4a857c$var$$g() {
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Xg = null;
}
function $17f526922e4a857c$var$ah(a) {
    var b = $17f526922e4a857c$var$Wg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$ch(a, b) {
    $17f526922e4a857c$var$Xg = a;
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$dh = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$eh(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Yg) {
            if (null === $17f526922e4a857c$var$Xg) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Yg = a;
            $17f526922e4a857c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Yg.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$fh = null;
function $17f526922e4a857c$var$gh(a) {
    null === $17f526922e4a857c$var$fh ? $17f526922e4a857c$var$fh = [
        a
    ] : $17f526922e4a857c$var$fh.push(a);
}
function $17f526922e4a857c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$ih(a, d);
}
function $17f526922e4a857c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$jh = !1;
function $17f526922e4a857c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$ih(a, c);
}
function $17f526922e4a857c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$th = {}, $17f526922e4a857c$var$uh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$vh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$wh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th);
function $17f526922e4a857c$var$xh(a) {
    if (a === $17f526922e4a857c$var$th) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$yh(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$wh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, $17f526922e4a857c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, b);
}
function $17f526922e4a857c$var$zh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$vh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$wh);
}
function $17f526922e4a857c$var$Ah(a) {
    $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
    var b = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, c));
}
function $17f526922e4a857c$var$Bh(a) {
    $17f526922e4a857c$var$vh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$uh), $17f526922e4a857c$var$E($17f526922e4a857c$var$vh));
}
var $17f526922e4a857c$var$L = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Dh = [];
function $17f526922e4a857c$var$Eh() {
    for(var a = 0; a < $17f526922e4a857c$var$Dh.length; a++)$17f526922e4a857c$var$Dh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Dh.length = 0;
}
var $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Hh = 0, $17f526922e4a857c$var$M = null, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$Ih = !1, $17f526922e4a857c$var$Jh = !1, $17f526922e4a857c$var$Kh = 0, $17f526922e4a857c$var$Lh = 0;
function $17f526922e4a857c$var$P() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Nh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Hh = f;
    $17f526922e4a857c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Fh.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Oh : $17f526922e4a857c$var$Ph;
    a = c(d, e);
    if ($17f526922e4a857c$var$Jh) {
        f = 0;
        do {
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Qh;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Jh);
    }
    $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
    b = null !== $17f526922e4a857c$var$N && null !== $17f526922e4a857c$var$N.next;
    $17f526922e4a857c$var$Hh = 0;
    $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
    $17f526922e4a857c$var$Ih = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$Sh() {
    var a = 0 !== $17f526922e4a857c$var$Kh;
    $17f526922e4a857c$var$Kh = 0;
    return a;
}
function $17f526922e4a857c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Uh() {
    if (null === $17f526922e4a857c$var$N) {
        var a = $17f526922e4a857c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$N.next;
    var b = null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState : $17f526922e4a857c$var$O.next;
    if (null !== b) $17f526922e4a857c$var$O = b, $17f526922e4a857c$var$N = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$N = a;
        a = {
            memoizedState: $17f526922e4a857c$var$N.memoizedState,
            baseState: $17f526922e4a857c$var$N.baseState,
            baseQueue: $17f526922e4a857c$var$N.baseQueue,
            queue: $17f526922e4a857c$var$N.queue,
            next: null
        };
        null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    }
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$Wh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$M.lanes |= m;
                $17f526922e4a857c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$M.lanes |= f, $17f526922e4a857c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$Xh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$Yh() {}
function $17f526922e4a857c$var$Zh(a, b) {
    var c = $17f526922e4a857c$var$M, d = $17f526922e4a857c$var$Uh(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$dh = !0);
    d = d.queue;
    $17f526922e4a857c$var$$h($17f526922e4a857c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$O && $17f526922e4a857c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
}
function $17f526922e4a857c$var$ai(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
    });
}
function $17f526922e4a857c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$ih(a, 1);
    null !== b && $17f526922e4a857c$var$gi(b, a, 1, -1);
}
function $17f526922e4a857c$var$hi(a) {
    var b = $17f526922e4a857c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ii.bind(null, $17f526922e4a857c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$ji() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$ki(a, b, c, d) {
    var e = $17f526922e4a857c$var$Th();
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    var e = $17f526922e4a857c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$N) {
        var g = $17f526922e4a857c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Mh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$bi(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, f, d);
}
function $17f526922e4a857c$var$mi(a, b) {
    return $17f526922e4a857c$var$ki(8390656, 8, a, b);
}
function $17f526922e4a857c$var$$h(a, b) {
    return $17f526922e4a857c$var$li(2048, 8, a, b);
}
function $17f526922e4a857c$var$ni(a, b) {
    return $17f526922e4a857c$var$li(4, 2, a, b);
}
function $17f526922e4a857c$var$oi(a, b) {
    return $17f526922e4a857c$var$li(4, 4, a, b);
}
function $17f526922e4a857c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$li(4, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$ri() {}
function $17f526922e4a857c$var$si(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ti(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ui(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$dh = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$M.lanes |= c, $17f526922e4a857c$var$rh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$vi(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Gh.transition;
    $17f526922e4a857c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Gh.transition = d;
    }
}
function $17f526922e4a857c$var$wi() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$xi(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, c);
    else if (c = $17f526922e4a857c$var$hh(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$R();
        $17f526922e4a857c$var$gi(c, a, d, e);
        $17f526922e4a857c$var$Bi(c, b, d);
    }
}
function $17f526922e4a857c$var$ii(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$hh(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$R(), $17f526922e4a857c$var$gi(c, a, d, e), $17f526922e4a857c$var$Bi(c, b, d));
    }
}
function $17f526922e4a857c$var$zi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$M || null !== b && b === $17f526922e4a857c$var$M;
}
function $17f526922e4a857c$var$Ai(a, b) {
    $17f526922e4a857c$var$Jh = $17f526922e4a857c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$Rh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$P,
    useContext: $17f526922e4a857c$var$P,
    useEffect: $17f526922e4a857c$var$P,
    useImperativeHandle: $17f526922e4a857c$var$P,
    useInsertionEffect: $17f526922e4a857c$var$P,
    useLayoutEffect: $17f526922e4a857c$var$P,
    useMemo: $17f526922e4a857c$var$P,
    useReducer: $17f526922e4a857c$var$P,
    useRef: $17f526922e4a857c$var$P,
    useState: $17f526922e4a857c$var$P,
    useDebugValue: $17f526922e4a857c$var$P,
    useDeferredValue: $17f526922e4a857c$var$P,
    useTransition: $17f526922e4a857c$var$P,
    useMutableSource: $17f526922e4a857c$var$P,
    useSyncExternalStore: $17f526922e4a857c$var$P,
    useId: $17f526922e4a857c$var$P,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Oh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ki(4194308, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$xi.bind(null, $17f526922e4a857c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$hi,
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$hi(!1), b = a[0];
        a = $17f526922e4a857c$var$vi.bind(null, a[1]);
        $17f526922e4a857c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$M, e = $17f526922e4a857c$var$Th();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$mi($17f526922e4a857c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$Th(), b = $17f526922e4a857c$var$Q.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Ph = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Wh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Qh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Xh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return null === $17f526922e4a857c$var$N ? b.memoizedState = a : $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $17f526922e4a857c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$R(), d = $17f526922e4a857c$var$yi(a), e = $17f526922e4a857c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$nh(a, e, d);
        null !== b && ($17f526922e4a857c$var$gi(b, a, d, c), $17f526922e4a857c$var$oh(b, a, d));
    }
};
function $17f526922e4a857c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$eh(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $17f526922e4a857c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$eh(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$Ei.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Ni(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Oi || ($17f526922e4a857c$var$Oi = !0, $17f526922e4a857c$var$Pi = d);
        $17f526922e4a857c$var$Li(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Qi(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Li(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Ri ? $17f526922e4a857c$var$Ri = new Set([
            this
        ]) : $17f526922e4a857c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$mh(-1, 1), b.tag = 2, $17f526922e4a857c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Wi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$dh = !1;
function $17f526922e4a857c$var$Xi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Vg(b, null, c, d) : $17f526922e4a857c$var$Ug(b, a.child, c, d);
}
function $17f526922e4a857c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$ch(b, e);
    d = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$bj(a, b, f, d, e);
        a = $17f526922e4a857c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$dh = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$Zi(a, b, e);
        }
    }
    return $17f526922e4a857c$var$cj(a, b, c, d, e);
}
function $17f526922e4a857c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj);
            $17f526922e4a857c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= d;
    $17f526922e4a857c$var$Xi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$ch(b, e);
    c = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$ch(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$ij(a, b), $17f526922e4a857c$var$Gi(b, c, d), $17f526922e4a857c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$eh(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$Hi(b, g, d, l);
        $17f526922e4a857c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof m && ($17f526922e4a857c$var$Di(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$eh(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$Hi(b, g, d, k);
        $17f526922e4a857c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof y && ($17f526922e4a857c$var$Di(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$jj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$jj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$Zi(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Ug(b, a.child, null, f), b.child = $17f526922e4a857c$var$Ug(b, null, h, f)) : $17f526922e4a857c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$yh(a, b.containerInfo);
}
function $17f526922e4a857c$var$lj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Xi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$pj(g, d, 0, null), a = $17f526922e4a857c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$nj(c), b.memoizedState = $17f526922e4a857c$var$mj, a) : $17f526922e4a857c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$Pg(h, f) : (f = $17f526922e4a857c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$qj(a, b) {
    b = $17f526922e4a857c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$sj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Ug(b, a.child, null, c);
    a = $17f526922e4a857c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$nj(g);
        b.memoizedState = $17f526922e4a857c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Ki(f, d, void 0);
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$dh || h) {
        d = $17f526922e4a857c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$ih(a, e), $17f526922e4a857c$var$gi(d, a, e, -1));
        }
        $17f526922e4a857c$var$tj();
        d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$bh(a.return, b, c);
}
function $17f526922e4a857c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Xi(a, b, d.children, c);
    d = $17f526922e4a857c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$vj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$kj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Ah(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$oj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
                a = $17f526922e4a857c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$dj(a, b, c);
    }
    return $17f526922e4a857c$var$Zi(a, b, c);
}
var $17f526922e4a857c$var$zj, $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj;
$17f526922e4a857c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Aj = function() {};
$17f526922e4a857c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Dj(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$zh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Aj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Bh(b);
            var e = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
                $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$L.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$Aj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Dj(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Gj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$L.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$fj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Ij(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Bh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$L), null;
        case 4:
            return $17f526922e4a857c$var$zh(), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Jj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Nj = !1;
function $17f526922e4a857c$var$Oj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Nj;
    $17f526922e4a857c$var$Nj = !1;
    return n;
}
function $17f526922e4a857c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Vj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Vj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Xj = !1;
function $17f526922e4a857c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$Zj(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$Zj(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Lj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Xj = !0;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Mj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Yj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Yj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Yj(a, b, c);
    }
}
function $17f526922e4a857c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Kj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Xj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$Zj(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$dk(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Pj(3, a, a.return), $17f526922e4a857c$var$Qj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Pj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            break;
        case 13:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$fk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$ek(a);
    }
}
function $17f526922e4a857c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$hk(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$ik(a, b, c);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Jj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Jj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$jk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$jk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$ik(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Jj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$kk(a, b, c);
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Rj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$gk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$jk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Qj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$lk = Math.ceil, $17f526922e4a857c$var$mk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$fj = 0, $17f526922e4a857c$var$ej = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$pk = null, $17f526922e4a857c$var$rh = 0, $17f526922e4a857c$var$qk = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = null, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$fk = 0, $17f526922e4a857c$var$Gj = Infinity, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Oi = !1, $17f526922e4a857c$var$Pi = null, $17f526922e4a857c$var$Ri = null, $17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = null, $17f526922e4a857c$var$xk = 0, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, $17f526922e4a857c$var$Ak = -1, $17f526922e4a857c$var$Bk = 0;
function $17f526922e4a857c$var$R() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$Ak : $17f526922e4a857c$var$Ak = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Bk && ($17f526922e4a857c$var$Bk = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Bk;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$gi(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$yk) throw $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$Q) a === $17f526922e4a857c$var$Q && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$qk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Ck(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Dk(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Dk(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Ek.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Ek.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Fk(c, $17f526922e4a857c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Gk(a, b) {
    $17f526922e4a857c$var$Ak = -1;
    $17f526922e4a857c$var$Bk = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Hk() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Ik(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Jk();
        if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Kk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Lk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Mk(a, h);
        }
        $17f526922e4a857c$var$$g();
        $17f526922e4a857c$var$mk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Nk(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Ok(e) && (b = $17f526922e4a857c$var$Ik(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Nk(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$fk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Gk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Nk(a, b) {
    var c = $17f526922e4a857c$var$sk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Kk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Ik(a, b);
    2 !== a && (b = $17f526922e4a857c$var$tk, $17f526922e4a857c$var$tk = c, null !== b && $17f526922e4a857c$var$Fj(b));
    return a;
}
function $17f526922e4a857c$var$Fj(a) {
    null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = a : $17f526922e4a857c$var$tk.push.apply($17f526922e4a857c$var$tk, a);
}
function $17f526922e4a857c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Ck(a, b) {
    b &= ~$17f526922e4a857c$var$rk;
    b &= ~$17f526922e4a857c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Ek(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Nk(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, b), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Qk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Rk(a) {
    null !== $17f526922e4a857c$var$wk && 0 === $17f526922e4a857c$var$wk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$ok.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$ok.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Hj() {
    $17f526922e4a857c$var$fj = $17f526922e4a857c$var$ej.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$ej);
}
function $17f526922e4a857c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$zh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Eh();
                break;
            case 5:
                $17f526922e4a857c$var$Bh(d);
                break;
            case 4:
                $17f526922e4a857c$var$zh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 10:
                $17f526922e4a857c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Hj();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$Q = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$Pg(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$fj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$pk = null;
    $17f526922e4a857c$var$rk = $17f526922e4a857c$var$qk = $17f526922e4a857c$var$rh = 0;
    $17f526922e4a857c$var$tk = $17f526922e4a857c$var$sk = null;
    if (null !== $17f526922e4a857c$var$fh) {
        for(b = 0; b < $17f526922e4a857c$var$fh.length; b++)if (c = $17f526922e4a857c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$fh = null;
    }
    return a;
}
function $17f526922e4a857c$var$Mk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$$g();
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
            if ($17f526922e4a857c$var$Ih) {
                for(var d = $17f526922e4a857c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Ih = !1;
            }
            $17f526922e4a857c$var$Hh = 0;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            $17f526922e4a857c$var$nk.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$pk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Si(f, l, b);
                            $17f526922e4a857c$var$tj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Vi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ji(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$sk ? $17f526922e4a857c$var$sk = [
                    f
                ] : $17f526922e4a857c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Ni(f, k, b);
                            $17f526922e4a857c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Qi(f, h, b);
                                $17f526922e4a857c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Sk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Jk() {
    var a = $17f526922e4a857c$var$mk.current;
    $17f526922e4a857c$var$mk.current = $17f526922e4a857c$var$Rh;
    return null === a ? $17f526922e4a857c$var$Rh : a;
}
function $17f526922e4a857c$var$tj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$Q || 0 === ($17f526922e4a857c$var$rh & 268435455) && 0 === ($17f526922e4a857c$var$qk & 268435455) || $17f526922e4a857c$var$Ck($17f526922e4a857c$var$Q, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Ik(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Jk();
    if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Kk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Tk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Mk(a, e);
    }
    $17f526922e4a857c$var$$g();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$mk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$Q = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Tk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Lk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Uk(a) {
    var b = $17f526922e4a857c$var$Vk(a.alternate, a, $17f526922e4a857c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Sk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$nk.current = null;
}
function $17f526922e4a857c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Ej(c, b, $17f526922e4a857c$var$fj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Pk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$ok.transition;
    try {
        $17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Wk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$ok.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Wk(a, b, c, d) {
    do $17f526922e4a857c$var$Hk();
    while (null !== $17f526922e4a857c$var$wk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$Q && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$vk || ($17f526922e4a857c$var$vk = !0, $17f526922e4a857c$var$Fk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$ok.transition;
        $17f526922e4a857c$var$ok.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$nk.current = null;
        $17f526922e4a857c$var$Oj(a, c);
        $17f526922e4a857c$var$dk(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$hk(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$ok.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$vk && ($17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = a, $17f526922e4a857c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Ri = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Oi) throw $17f526922e4a857c$var$Oi = !1, a = $17f526922e4a857c$var$Pi, $17f526922e4a857c$var$Pi = null, a;
    0 !== ($17f526922e4a857c$var$xk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$zk ? $17f526922e4a857c$var$yk++ : ($17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = a) : $17f526922e4a857c$var$yk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Hk() {
    if (null !== $17f526922e4a857c$var$wk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$xk), b = $17f526922e4a857c$var$ok.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$ok.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$wk) var d = !1;
            else {
                a = $17f526922e4a857c$var$wk;
                $17f526922e4a857c$var$wk = null;
                $17f526922e4a857c$var$xk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Sj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$ok.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Xk(a, b, c) {
    b = $17f526922e4a857c$var$Ji(c, b);
    b = $17f526922e4a857c$var$Ni(a, b, 1);
    a = $17f526922e4a857c$var$nh(a, b, 1);
    b = $17f526922e4a857c$var$R();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Dk(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(d))) {
                a = $17f526922e4a857c$var$Ji(c, a);
                a = $17f526922e4a857c$var$Qi(b, a, 1);
                b = $17f526922e4a857c$var$nh(b, a, 1);
                a = $17f526922e4a857c$var$R();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$Q === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$fk ? $17f526922e4a857c$var$Kk(a, 0) : $17f526922e4a857c$var$rk |= c);
    $17f526922e4a857c$var$Dk(a, b);
}
function $17f526922e4a857c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$R();
    a = $17f526922e4a857c$var$ih(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Dk(a, c));
}
function $17f526922e4a857c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Yk(a, c);
}
function $17f526922e4a857c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Yk(a, c);
}
var $17f526922e4a857c$var$Vk;
$17f526922e4a857c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$yj(a, b, c);
            $17f526922e4a857c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$ij(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$ch(b, c);
            e = $17f526922e4a857c$var$Nh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$kh(b), e.updater = $17f526922e4a857c$var$Ei, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$Ii(b, d, a, c), b = $17f526922e4a857c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$Zk(d);
                a = $17f526922e4a857c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$$i(null, b, d, $17f526922e4a857c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$kj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$lh(a, b);
                $17f526922e4a857c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$Zi(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Ah(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$gj(a, b), $17f526922e4a857c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$oj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Ug(b, null, d, c) : $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$Yi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$ch(b, c), e = $17f526922e4a857c$var$eh(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Ci(d, b.pendingProps), e = $17f526922e4a857c$var$Ci(d.type, e), $17f526922e4a857c$var$$i(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$ij(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$ch(b, c), $17f526922e4a857c$var$Gi(b, d, e), $17f526922e4a857c$var$Ii(b, d, e, c), $17f526922e4a857c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$xj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$dj(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Fk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$$k(a, b, c, d);
}
function $17f526922e4a857c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$Zk(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Tg(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Tg(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$pj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$Qg(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$kh(f);
    return a;
}
function $17f526922e4a857c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$dl(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$dl(null);
    c = a.current;
    d = $17f526922e4a857c$var$R();
    e = $17f526922e4a857c$var$yi(c);
    f = $17f526922e4a857c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$nh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Dk(a, d);
    return a;
}
function $17f526922e4a857c$var$fl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$R(), g = $17f526922e4a857c$var$yi(e);
    c = $17f526922e4a857c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$nh(e, b, g);
    null !== a && ($17f526922e4a857c$var$gi(a, e, g, f), $17f526922e4a857c$var$oh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    $17f526922e4a857c$var$hl(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$hl(a, b);
}
function $17f526922e4a857c$var$jl() {
    return null;
}
var $17f526922e4a857c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ll(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.render = $17f526922e4a857c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$fl(a, b, null, null);
};
$17f526922e4a857c$var$ml.prototype.unmount = $17f526922e4a857c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Rk(function() {
            $17f526922e4a857c$var$fl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$pl() {}
function $17f526922e4a857c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$gl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$el(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$pl);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$gl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$bl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$pl);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$fl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$gl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$fl(b, g, a, e);
    } else g = $17f526922e4a857c$var$ql(c, b, a, e, d);
    return $17f526922e4a857c$var$gl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Dk(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Rk(function() {
                var b = $17f526922e4a857c$var$ih(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$R();
                    $17f526922e4a857c$var$gi(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$il(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$il(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$yi(a), c = $17f526922e4a857c$var$ih(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(c, a, b, d);
        }
        $17f526922e4a857c$var$il(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Rk;
var $17f526922e4a857c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Qk
    ]
}, $17f526922e4a857c$var$tl = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$ul = {
    bundleType: $17f526922e4a857c$var$tl.bundleType,
    version: $17f526922e4a857c$var$tl.version,
    rendererPackageName: $17f526922e4a857c$var$tl.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$tl.findFiberByHostInstance || $17f526922e4a857c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$vl.isDisabled && $17f526922e4a857c$var$vl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$vl.inject($17f526922e4a857c$var$ul), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$vl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$sl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$nl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$cl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ll(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Rk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$ol(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$rl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("clk2u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
"use strict";
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});



parcelRegister("O6tRJ", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

var $2214d54dffb366cc$exports = {};


(parcelRequire("7ayQm")).register((parcelRequire("lIGhs")).getBundleURL("hstjT"), JSON.parse('["hstjT","rivara-ai.js","bQGFb","ari_minimized.8b220e5a.webp","jHrAa","no-avatar.ed99f9d0.webp","d3dBz","default_logo.f363ad9a.png","9PYX8","hotline_thumbnail.18d57565.webp","c51bY","warmline_thumbnail.53790628.webp","h5kt0","sms_hotline_thumbnail.540ae242.webp","61SUf","sms_warmline_thumbnail.4552537a.webp","dP6yb","phone-solid-white.2cd74882.svg","aBneJ","global-white.40787e15.svg","2I1kf","message-bubble-white.5cdd0a77.svg","lIbNM","phone-solid.1c6138d0.svg","f78f3","message-bubble.7692c3c9.svg","6YC5M","mobile-checkins.c2a4123d.svg","X3BpD","circle-check.44ba47e6.svg","lNpJx","close.bc7dfc3c.svg","4kIY4","minus.f7625ea0.svg","k3mPY","angle-left-solid.3468c917.svg","6JFxi","rivara-ai.css"]'));

// src/wr-web-component.js
var $13f4c0370d7de649$exports = {};
"use strict";

$13f4c0370d7de649$exports = (parcelRequire("89wqa"));


// Polyfill for creating CustomEvents on IE9/10/11
// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
(function() {
    if (typeof window === "undefined") return;
    try {
        var ce = new window.CustomEvent("test", {
            cancelable: true
        });
        ce.preventDefault();
        if (ce.defaultPrevented !== true) // IE has problems with .preventDefault() on custom events
        // http://stackoverflow.com/questions/23349191
        throw new Error("Could not prevent default");
    } catch (e) {
        var CustomEvent = function(event, params) {
            var evt, origPrevent;
            params = params || {};
            params.bubbles = !!params.bubbles;
            params.cancelable = !!params.cancelable;
            evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            origPrevent = evt.preventDefault;
            evt.preventDefault = function() {
                origPrevent.call(this);
                try {
                    Object.defineProperty(this, "defaultPrevented", {
                        get: function() {
                            return true;
                        }
                    });
                } catch (e) {
                    this.defaultPrevented = true;
                }
            };
            return evt;
        };
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent; // expose definition to window
    }
})();



var $8NFma = parcelRequire("8NFma");
var $1c0f1e610963dfb8$exports = {};
"use strict";
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

$1c0f1e610963dfb8$exports = (parcelRequire("23wBm"));


var $3ec54c74e9243781$var$C = Object.defineProperty;
var $3ec54c74e9243781$var$x = (t, e, s)=>e in t ? $3ec54c74e9243781$var$C(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : t[e] = s;
var $3ec54c74e9243781$var$h = (t, e, s)=>($3ec54c74e9243781$var$x(t, typeof e != "symbol" ? e + "" : e, s), s);
const $3ec54c74e9243781$var$T = {
    stringify: (t)=>t,
    parse: (t)=>t
}, $3ec54c74e9243781$var$V = {
    stringify: (t)=>`${t}`,
    parse: (t)=>parseFloat(t)
}, $3ec54c74e9243781$var$N = {
    stringify: (t)=>t ? "true" : "false",
    parse: (t)=>/^[ty1-9]/i.test(t)
}, $3ec54c74e9243781$var$P = {
    stringify: (t)=>t.name,
    parse: (t, e, s)=>{
        const c = (()=>{
            if (typeof window < "u" && t in window) return window[t];
            if (typeof $parcel$global < "u" && t in $parcel$global) return $parcel$global[t];
        })();
        return typeof c == "function" ? c.bind(s) : void 0;
    }
}, $3ec54c74e9243781$var$$ = {
    stringify: (t)=>JSON.stringify(t),
    parse: (t)=>JSON.parse(t)
}, $3ec54c74e9243781$var$A = {
    string: $3ec54c74e9243781$var$T,
    number: $3ec54c74e9243781$var$V,
    boolean: $3ec54c74e9243781$var$N,
    function: $3ec54c74e9243781$var$P,
    json: $3ec54c74e9243781$var$$
};
function $3ec54c74e9243781$var$J(t) {
    return t.replace(/([a-z0-9])([A-Z])/g, (e, s, c)=>`${s}-${c.toLowerCase()}`);
}
const $3ec54c74e9243781$var$d = Symbol.for("r2wc.render"), $3ec54c74e9243781$var$g = Symbol.for("r2wc.connected"), $3ec54c74e9243781$var$l = Symbol.for("r2wc.context"), $3ec54c74e9243781$var$p = Symbol.for("r2wc.props");
function $3ec54c74e9243781$export$2e2bcd8739ae039(t, e, s) {
    var k, O, j;
    e.props || (e.props = t.propTypes ? Object.keys(t.propTypes) : []);
    const c = Array.isArray(e.props) ? e.props.slice() : Object.keys(e.props), b = {}, m = {}, w = {};
    for (const r of c){
        b[r] = Array.isArray(e.props) ? "string" : e.props[r];
        const u = $3ec54c74e9243781$var$J(r);
        m[r] = u, w[u] = r;
    }
    class S extends HTMLElement {
        constructor(){
            super();
            $3ec54c74e9243781$var$h(this, k, !0);
            $3ec54c74e9243781$var$h(this, O);
            $3ec54c74e9243781$var$h(this, j, {});
            $3ec54c74e9243781$var$h(this, "container");
            e.shadow ? this.container = this.attachShadow({
                mode: e.shadow
            }) : this.container = this, this[$3ec54c74e9243781$var$p].container = this.container;
            for (const n of c){
                const f = m[n], o = this.getAttribute(f), i = b[n], a = i ? $3ec54c74e9243781$var$A[i] : null;
                a != null && a.parse && o && (this[$3ec54c74e9243781$var$p][n] = a.parse(o, f, this));
            }
        }
        static get observedAttributes() {
            return Object.keys(w);
        }
        connectedCallback() {
            this[$3ec54c74e9243781$var$g] = !0, this[$3ec54c74e9243781$var$d]();
        }
        disconnectedCallback() {
            this[$3ec54c74e9243781$var$g] = !1, this[$3ec54c74e9243781$var$l] && s.unmount(this[$3ec54c74e9243781$var$l]), delete this[$3ec54c74e9243781$var$l];
        }
        attributeChangedCallback(n, f, o) {
            const i = w[n], a = b[i], y = a ? $3ec54c74e9243781$var$A[a] : null;
            i in b && y != null && y.parse && o && (this[$3ec54c74e9243781$var$p][i] = y.parse(o, n, this), this[$3ec54c74e9243781$var$d]());
        }
        [(k = $3ec54c74e9243781$var$g, O = $3ec54c74e9243781$var$l, j = $3ec54c74e9243781$var$p, $3ec54c74e9243781$var$d)]() {
            this[$3ec54c74e9243781$var$g] && (this[$3ec54c74e9243781$var$l] ? s.update(this[$3ec54c74e9243781$var$l], this[$3ec54c74e9243781$var$p]) : this[$3ec54c74e9243781$var$l] = s.mount(this.container, t, this[$3ec54c74e9243781$var$p]));
        }
    }
    for (const r of c){
        const u = m[r], n = b[r];
        Object.defineProperty(S.prototype, r, {
            enumerable: !0,
            configurable: !0,
            get () {
                return this[$3ec54c74e9243781$var$p][r];
            },
            set (f) {
                this[$3ec54c74e9243781$var$p][r] = f;
                const o = n ? $3ec54c74e9243781$var$A[n] : null;
                if (o != null && o.stringify) {
                    const i = o.stringify(f, u, this);
                    this.getAttribute(u) !== i && this.setAttribute(u, i);
                } else this[$3ec54c74e9243781$var$d]();
            }
        });
    }
    return S;
}


function $b51cd1de320412c4$export$2e2bcd8739ae039(m, i, e, d = {}) {
    function f(r, n, u) {
        const o = i.createElement(n, u);
        if ("createRoot" in e) {
            const t = e.createRoot(r);
            return t.render(o), {
                container: r,
                root: t,
                ReactComponent: n
            };
        }
        if ("render" in e) return e.render(o, r), {
            container: r,
            ReactComponent: n
        };
        throw new Error("Invalid ReactDOM instance provided.");
    }
    function p({ container: r, root: n, ReactComponent: u }, o) {
        const t = i.createElement(u, o);
        if (n) {
            n.render(t);
            return;
        }
        if ("render" in e) {
            e.render(t, r);
            return;
        }
    }
    function l({ container: r, root: n }) {
        if (n) {
            n.unmount();
            return;
        }
        if ("unmountComponentAtNode" in e) {
            e.unmountComponentAtNode(r);
            return;
        }
    }
    return (0, $3ec54c74e9243781$export$2e2bcd8739ae039)(m, d, {
        mount: f,
        unmount: l,
        update: p
    });
}


// src/ChatButton.js


var $8NFma = parcelRequire("8NFma");
parcelRequire("O6tRJ");


var $8NFma = parcelRequire("8NFma");
parcelRequire("O6tRJ");
"use strict";
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== "object") return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest("URLSearchParams");
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest("HTMLFormElement");
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest("RegExp");
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $aace3e920a0f1e4d$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $aace3e920a0f1e4d$var$DIGIT = "0123456789";
const $aace3e920a0f1e4d$var$ALPHABET = {
    DIGIT: $aace3e920a0f1e4d$var$DIGIT,
    ALPHA: $aace3e920a0f1e4d$var$ALPHA,
    ALPHA_DIGIT: $aace3e920a0f1e4d$var$ALPHA + $aace3e920a0f1e4d$var$ALPHA.toUpperCase() + $aace3e920a0f1e4d$var$DIGIT
};
const $aace3e920a0f1e4d$var$generateString = (size = 16, alphabet = $aace3e920a0f1e4d$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest("AsyncFunction");
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    ALPHABET: $aace3e920a0f1e4d$var$ALPHABET,
    generateString: $aace3e920a0f1e4d$var$generateString,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf);
    else return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0934e0939605d48c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $8a0a73e6b73fd0c4$export$d622b2ad8d90c771($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $fd07b9cb0132c1f6$require$Buffer = $0934e0939605d48c$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





"use strict";
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


"use strict";
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $232de52881daaba8$exports = {};

$parcel$export($232de52881daaba8$exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export($232de52881daaba8$exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = ((product)=>{
    return $232de52881daaba8$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$232de52881daaba8$exports,
    ...(0, $fb24c6d0b2a74508$export$2e2bcd8739ae039)
};


"use strict";
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isResponse(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $54e5234108b8e954$var$$internals = Symbol("internals");
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


"use strict";
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($63b8b72909769bf2$var$CanceledError, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







"use strict";
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


"use strict";
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    const threshold = 1000 / freq;
    let timer = null;
    return function throttled() {
        const force = this === true;
        const now = Date.now();
        if (force || now - timestamp > threshold) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timestamp = now;
            return fn.apply(null, arguments);
        }
        if (!timer) timer = setTimeout(()=>{
            timer = null;
            timestamp = Date.now();
            return fn.apply(null, arguments);
        }, threshold - (now - timestamp));
    };
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;


var $a01f222f203440ec$export$2e2bcd8739ae039 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (0, $bab2be24834f7155$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    }, freq);
};






"use strict";
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL)) return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $f612969e780f42a0$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)((0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType } = _config;
        let onCanceled;
        function done() {
            if (_config.cancelToken) _config.cancelToken.unsubscribe(onCanceled);
            if (_config.signal) _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request aborted", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Network Error", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, _config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (typeof _config.onDownloadProgress === "function") request.addEventListener("progress", (0, $a01f222f203440ec$export$2e2bcd8739ae039)(_config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof _config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", (0, $a01f222f203440ec$export$2e2bcd8739ae039)(_config.onUploadProgress));
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $852831b4a152a7ad$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) ? err : new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;


const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $ac31e9e363273572$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    return new ReadableStream({
        type: "bytes",
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                controller.close();
                onFinish();
                return;
            }
            let len = value.byteLength;
            onProgress && onProgress(bytes += len);
            controller.enqueue(new Uint8Array(value));
        },
        cancel (reason) {
            onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $4b9898a31eea6843$var$fetchProgressDecorator = (total, fn)=>{
    const lengthComputable = total != null;
    return (loaded)=>setTimeout(()=>fn({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }));
};
const $4b9898a31eea6843$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $4b9898a31eea6843$var$isReadableStreamSupported = $4b9898a31eea6843$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $4b9898a31eea6843$var$encodeText = $4b9898a31eea6843$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $4b9898a31eea6843$var$supportsRequestStream = $4b9898a31eea6843$var$isReadableStreamSupported && (()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const $4b9898a31eea6843$var$supportsResponseStream = $4b9898a31eea6843$var$isReadableStreamSupported && !!(()=>{
    try {
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
    } catch (err) {
    // return undefined
    }
})();
const $4b9898a31eea6843$var$resolvers = {
    stream: $4b9898a31eea6843$var$supportsResponseStream && ((res)=>res.body)
};
$4b9898a31eea6843$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$4b9898a31eea6843$var$resolvers[type] && ($4b9898a31eea6843$var$resolvers[type] = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $4b9898a31eea6843$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(body)) return body.byteLength;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(body)) return (await $4b9898a31eea6843$var$encodeText(body)).byteLength;
};
const $4b9898a31eea6843$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $4b9898a31eea6843$var$getBodyLength(body) : length;
};
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $8bc8ab02f7e95517$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $4b9898a31eea6843$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $4b9898a31eea6843$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) data = (0, $ac31e9e363273572$export$b0119225647bd83)(_request.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, $4b9898a31eea6843$var$fetchProgressDecorator(requestContentLength, (0, $a01f222f203440ec$export$2e2bcd8739ae039)(onUploadProgress)), null, $4b9898a31eea6843$var$encodeText);
        }
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "cors" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            withCredentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $4b9898a31eea6843$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($4b9898a31eea6843$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            response = new Response((0, $ac31e9e363273572$export$b0119225647bd83)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onDownloadProgress && $4b9898a31eea6843$var$fetchProgressDecorator(responseContentLength, (0, $a01f222f203440ec$export$2e2bcd8739ae039)(onDownloadProgress, true)), isStreamResponse && onFinish, $4b9898a31eea6843$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $4b9898a31eea6843$var$resolvers[(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey($4b9898a31eea6843$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Network Error", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039),
    fetch: (0, $4b9898a31eea6843$export$2e2bcd8739ae039)
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($d570c100e0cb7a05$var$renderReason).join("\n") : " " + $d570c100e0cb7a05$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $4c74d331112ba968$export$a4ad2735b021c132 = "1.7.2";



"use strict";
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $4c74d331112ba968$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("options must be an object", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};



"use strict";
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






"use strict";
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);


// workaround (associate with our db)
// referring to: https://www.metamodpro.com/browser-language-codes
const $9fb14afd948dd65e$export$b14d944ce04c06f6 = {
    "en-US": "en"
};
const $9fb14afd948dd65e$export$38b520220a8566d9 = {
    zh: "zh-Hans",
    en: "en-US",
    fr: "fr-FR",
    "zh-cn": "zh-Hans",
    "zh-sg": "zh-Hans",
    "zh-hk": "zh-Hant",
    "zh-tw": "zh-Hant",
    "zh-mo": "zh-Hant",
    "fr-ca": "fr-CA"
};
var $9fb14afd948dd65e$export$2e2bcd8739ae039 = (lang, country)=>{
    // map (lang+country from db) to browser standard
    // const langMapped = mappingLang[lang] || lang
    const langMapped = $9fb14afd948dd65e$export$b14d944ce04c06f6[lang] || lang;
    let mappingCountry;
    let defaultCountry = "";
    if (langMapped === "en") {
        defaultCountry = "GB";
        mappingCountry = {
            AT: "AT",
            CA: "CA",
            GB: "GB",
            US: "US"
        };
    }
    if (langMapped === "es") mappingCountry = {
        ES: "ES",
        MX: "MX"
    };
    if (langMapped === "fr") mappingCountry = {
        CA: "CA",
        FR: "FR"
    };
    if (langMapped === "pt") mappingCountry = {
        BR: "BR",
        PT: "PT"
    };
    const countryMapped = mappingCountry ? mappingCountry[country] || defaultCountry : "";
    const langConcat = langMapped + (countryMapped ? "-" + countryMapped : "");
    return langConcat;
};


let $726aa11b12c82653$var$SERVER = "https://api.ww.mbdtst.com";
let $726aa11b12c82653$var$CND_SERVER = "https://cdn.ww.mbdtst.com";
$726aa11b12c82653$var$SERVER = "https://api.rivara.ai";
$726aa11b12c82653$var$CND_SERVER = "https://cdn.rivara.ai";
if ("stage"?.trim() == "dev" || "stage"?.trim() == "stage") console.log("process.env.BUILD_FOR", "stage");
if ("stage"?.trim() == "dev") {
    // SERVER = 'http://localhost:8080'
    $726aa11b12c82653$var$SERVER = "https://api.ww.mbdtst.com";
    $726aa11b12c82653$var$CND_SERVER = "https://cdn.ww.mbdtst.com";
}
if ("stage"?.trim() == "stage") {
    $726aa11b12c82653$var$SERVER = "https://api.ww.mbdtst.com";
    $726aa11b12c82653$var$CND_SERVER = "https://cdn.ww.mbdtst.com";
}
if ("stage"?.trim() == "live") {
    $726aa11b12c82653$var$SERVER = "https://api.rivara.ai";
    $726aa11b12c82653$var$CND_SERVER = "https://cdn.rivara.ai";
}
const $726aa11b12c82653$var$headers = {};
const $726aa11b12c82653$var$request = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).create({
    baseURL: $726aa11b12c82653$var$SERVER + "/wc/heatherai",
    headers: $726aa11b12c82653$var$headers
});
const $726aa11b12c82653$var$browserLanguage = ()=>{
    let l_lang;
    if (navigator.userLanguage) // Explorer
    l_lang = navigator.userLanguage;
    else if (navigator.language) // FF
    l_lang = navigator.language;
    else l_lang = "";
    // some languages has different standard between browser and BCP-47
    l_lang = l_lang.toLowerCase();
    l_lang = (0, $9fb14afd948dd65e$export$38b520220a8566d9)[l_lang] || (0, $9fb14afd948dd65e$export$38b520220a8566d9)[l_lang.split("-")[0]] || l_lang.split("-")[0];
    if ("stage"?.trim() == "dev" || "stage"?.trim() == "stage") console.log("browser language code:", l_lang);
    return l_lang;
};
const $726aa11b12c82653$var$getQString = (queryObj)=>{
    if (!queryObj.lang) queryObj.browserLang = $726aa11b12c82653$var$browserLanguage();
    const params = [];
    for(const key in queryObj)params.push(`${key}=${queryObj[key] || ""}`);
    return params.join("&");
};
var $726aa11b12c82653$export$2e2bcd8739ae039 = {
    SERVER: $726aa11b12c82653$var$SERVER,
    CND_SERVER: $726aa11b12c82653$var$CND_SERVER,
    async getToken (access_code) {
        const res = await $726aa11b12c82653$var$request.get(`/token?access=${access_code}`);
        const data = res?.data;
        return data;
    },
    async getSettings (accesstoken, lang, country, { isPreview: isPreview }) {
        const qString = $726aa11b12c82653$var$getQString({
            accesstoken: accesstoken,
            lang: lang,
            country: country,
            isPreview: isPreview
        });
        const res = await $726aa11b12c82653$var$request.get(`/settings?${qString}`);
        const data = res?.data;
        return data;
    },
    async getTree (accesstoken, lang, country, { cookieOff: cookieOff, isPreview: isPreview }) {
        const qString = $726aa11b12c82653$var$getQString({
            accesstoken: accesstoken,
            lang: lang,
            country: country,
            cookieOff: cookieOff,
            isPreview: isPreview
        });
        const res = await $726aa11b12c82653$var$request.get(`?${qString}`);
        let data = res?.data;
        // convert data to json string replace @base_url with CND_SERVER, then parse it back to json object
        if (data) {
            let dataString = JSON.stringify(data);
            dataString = dataString.replace(/@base_url/g, $726aa11b12c82653$var$CND_SERVER);
            data = JSON.parse(dataString);
            const language_code = data?.currentLanguage;
            if (language_code) localStorage.setItem("rivara_currentLanguage", language_code);
            const country_code = data?.currentCountry;
            if (country_code) localStorage.setItem("rivara_currentCountry", country_code);
        }
        if ("stage"?.trim() == "dev" || "stage"?.trim() == "stage") console.log("getTree data", data);
        return data;
    },
    async getResults (accesstoken, { sCodes: sCodes, sCodes_or: sCodes_or, sCodes_notexists: sCodes_notexists, input: input, lang: lang, country: country }, { isPreview: isPreview }) {
        const params = {
            sCodes: sCodes,
            sCodes_or: sCodes_or,
            sCodes_notexists: sCodes_notexists,
            input: input
        };
        const qString = $726aa11b12c82653$var$getQString({
            accesstoken: accesstoken,
            lang: lang,
            country: country,
            isPreview: isPreview
        });
        const res = await $726aa11b12c82653$var$request.post(`/action/RESULTS?${qString}`, params);
        const data = res?.data;
        // test
        return data;
    },
    async getFacility (accesstoken, org_id, { isPreview: isPreview }) {
        const qString = $726aa11b12c82653$var$getQString({
            accesstoken: accesstoken,
            isPreview: isPreview
        });
        const res = await $726aa11b12c82653$var$request.get(`/facility/${org_id}?${qString}`);
        const data = res?.data;
        return data;
    },
    async recordEngagement (o) {
        const { isPreview: isPreview } = o;
        if (isPreview) {
            console.log("you are in preview mode, skip record engagement", o);
            return null;
        }
        const res = await $726aa11b12c82653$var$request.post(`/record`, o);
        const data = res?.data;
        return data;
    },
    async recordVisitor ({ visitor_token: visitor_token, accesstoken: accesstoken, isPreview: isPreview }) {
        if (isPreview) {
            console.log("you are in preview mode, skip record visitor", {
                visitor_token: visitor_token,
                accesstoken: accesstoken
            });
            return null;
        }
        const res = await $726aa11b12c82653$var$request.post(`/recordVisitor`, {
            visitor_token: visitor_token,
            accesstoken: accesstoken
        });
        const data = res?.data;
        return data;
    }
};




var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");

const $b2e6864aad7029da$export$4cea97e757f1b48b = {
    EXTERNAL: "EXTERNAL",
    ABSOLUTE: "ABSOLUTE",
    RELATIVE: "RELATIVE",
    PDF: "EXTERNAL",
    MAIL: "EXTERNAL",
    PHONE: "EXTERNAL"
};
const $b2e6864aad7029da$export$d0481747ec78f293 = 600;
var $b2e6864aad7029da$export$2e2bcd8739ae039 = {
    // ====== for UI level ======
    characters: {
        USER: "USER",
        BOT: "BOT",
        SYSTEM: "SYSTEM",
        STAGEMANAGER: "STAGEMANAGER"
    },
    stepForSystem: {
        RESULTS: "RESULTS",
        ENTRY: "ENTRY"
    },
    scodeMethods: {
        ATTACH: "ATTACH",
        REPLACE: "REPLACE",
        // -- default
        default: "ATTACH"
    },
    stepTypes: {
        OPTIONS: "OPTIONS",
        SKIP: "SKIP",
        HTMLPANEL: "HTMLPANEL",
        LOC_ZIP: "LOC_ZIP",
        OPTIONS_ONLY: "OPTIONS_ONLY",
        RESULTS: "RESULTS",
        // -- default
        default: "OPTIONS"
    },
    operations: {
        AND: "AND",
        OR: "OR",
        NOTEXISTS: "NOTEXISTS",
        // -- default
        default: "AND"
    },
    messageTypes: {
        BUBBLE: "BUBBLE",
        HTMLPANEL: "HTMLPANEL",
        // -- default
        default: "BUBBLE"
    },
    TIME_BREAK_BETWEEN_MESSAGE: $b2e6864aad7029da$export$d0481747ec78f293,
    // ====== for data level ======
    drawers: {
        "facility": "facility",
        "settings": "settings"
    },
    ACTIVITY_TYPES: {
        "FAC_DETAIL": "FAC_DETAIL",
        "FAC_EXT_WEBSITE": "FAC_EXT_WEBSITE",
        "FAC_EXT_HOTLINE": "FAC_EXT_HOTLINE",
        "FAC_EXT_WARMLINE": "FAC_EXT_WARMLINE",
        "FAC_EXT_PHONE": "FAC_EXT_PHONE",
        "FAC_EXT_SMS": "FAC_EXT_SMS"
    }
};



var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");


/**
 * directs the conversation flow. focus on who should speak next
 * wont do stage changes, only assign tasks (to prevent potential infinite loop)
 * @param {*} props
 */ const $3cedcce6badbf08d$var$useDirector = (props)=>{
    const { tree: tree, stage: stage, setStage: setStage, waitingQueue: waitingQueue, onSchedulePerformanceList: onSchedulePerformanceList, onError: onError } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    (0, $8NFma.useEffect)(()=>{
        // if there is no waiting queue, director assign tasks
        if (stage && tree && (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).isEmpty(waitingQueue)) process(stage, tree);
    }, [
        stage,
        tree,
        waitingQueue
    ]);
    const process = (stage, tree)=>{
        /* 
      when queue is empty, director will assign tasks
      check if there is a next step, if not, means
      1. either logicTree configuration is wrong. (need to fix from the CMS)
      2. role is not properly setup the next step. (need to fix from front-end)
      throw exception
    */ const { currentStep: currentStep, nextStep: nextStep } = stage;
        const nextStepObj = tree[nextStep];
        if (!nextStepObj) {
            console.error("No next step. Conversation ended. nextStep code is:", nextStep);
            onError("No next step. Conversation ended.");
            return;
        }
        // according to the next step type, assign to different actor. Some steps needs multiple actors
        const nextType = nextStepObj.type || (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.default // default "OPTIONS"
        ;
        console.log("director assign", nextType, nextStepObj);
        /* 
      director enqueue (actor will run similar "switch-case" but: 1.limited to their character, 2. more detailed action)
      primary purpose of director is: to split codes into different hooks (I call it assign tasks)
      
      for roles:
      - "system"/"bot": will aggressively pick tasks, 
      - "user" task will be:
        render the input whenever conditions are met (e.g. current step has "options" field, or type is "loc_zip")
        awaiting user input, once done, task will auto dequeue from waitingQueue. Its to satisfy the process
      - "stagemanager" will be the exception handler, it doesnt pick task. It will showup when there is an exception
    */ switch(nextType){
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.SKIP:
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.CLEAR:
                onSchedulePerformanceList({
                    step: nextStep,
                    character: (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.SYSTEM // let system process variables
                });
                break;
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.HTMLPANEL:
                // bot only
                onSchedulePerformanceList({
                    step: nextStep,
                    character: (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.BOT
                });
                break;
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.RESULTS:
                // bot sends a message(only if there is), then system will process the results
                onSchedulePerformanceList({
                    step: nextStep,
                    character: (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.BOT
                }, {
                    step: nextStep,
                    character: (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.SYSTEM
                });
                break;
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.OPTIONS:
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.OPTIONS_ONLY:
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.LOC_ZIP:
                // bot sends a message, then awaiting for user input
                onSchedulePerformanceList({
                    step: nextStep,
                    character: (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.BOT // let system process variables
                }, {
                    step: nextStep,
                    character: (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.USER // let system process variables
                });
                break;
            default:
                break;
        }
        return;
    };
};
var $3cedcce6badbf08d$export$2e2bcd8739ae039 = $3cedcce6badbf08d$var$useDirector;



var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");


const $73d96a00ab44ec17$var$CHARACTER = (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.BOT;
/**
 * passively listens for stage changes
 * @param {*} props
 */ const $73d96a00ab44ec17$var$useBot = (props)=>{
    const { tree: tree, stage: stage, setStage: setStage, onSpeakLine: onSpeakLine, waitingQueue: waitingQueue, onClaimPerformance: onClaimPerformance, onPerformance: onPerformance } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    (0, $8NFma.useEffect)(()=>{
        if (tree) {
            const performance = onClaimPerformance($73d96a00ab44ec17$var$CHARACTER);
            if (performance) // await 1s then process
            process(stage, tree, performance);
        }
    }, [
        stage,
        tree,
        waitingQueue
    ]);
    const process = async (stage, tree, performance)=>{
        onPerformance(true);
        const { step: step } = performance;
        // current step
        const { question: question, html: html, message: message, action: action } = tree[step] || {};
        const currentType = tree[step]?.type;
        // TODO: in the future if need backend data, should use Promise.all
        // await 1s before speaking
        await new Promise((resolve)=>setTimeout(resolve, (0, $b2e6864aad7029da$export$2e2bcd8739ae039).TIME_BREAK_BETWEEN_MESSAGE));
        // if no message. BOT will skip it.
        /*
      here is redundant setting. both question and html will be displayed.
      reason is to support legacy package react-simple-chatbot. we no longer needs it
    */ let displayMessage = message || question || html || null;
        if (displayMessage) onSpeakLine($73d96a00ab44ec17$var$CHARACTER, {
            chatMessage: displayMessage
        }, currentType);
        setStage((prev)=>{
            const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(prev);
            (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "behavior.currentActor", $73d96a00ab44ec17$var$CHARACTER);
            /* 
        original reason we store 2 steps-- when awaiting user input. we need to:
        InputZone component needs to grab variables from current step
        director still need to know know what next step to go
        ======
        we keep updating 2 steps, but until director pick it up, it will not be processed. 
        so only latest update will be processed 
        reason is the "action" can be from different sources. (user select option / "SKIP" step)
      */ (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "currentStep", step);
            if (action) (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "nextStep", action);
            return _v;
        });
        onPerformance(false);
    };
};
var $73d96a00ab44ec17$export$2e2bcd8739ae039 = $73d96a00ab44ec17$var$useBot;



var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");





const $2807b35e372d459e$var$CHARACTER = (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.SYSTEM;
/**
 * passively listens for stage changes
 * system usually interacts with the backend then send message to chatbox
 * @param {*} props
 */ const $2807b35e372d459e$var$useSystem = (props)=>{
    const { tree: tree, stage: stage, setStage: setStage, onSpeakLine: onSpeakLine, onCancelSpeakLine: onCancelSpeakLine, waitingQueue: waitingQueue, onClaimPerformance: onClaimPerformance, onPerformance: onPerformance, onProcessPayload: onProcessPayload, onFetchResults: //
    onFetchResults } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    (0, $8NFma.useEffect)(()=>{
        if (tree) {
            const performance = onClaimPerformance($2807b35e372d459e$var$CHARACTER);
            if (performance) process(stage, tree, performance);
        }
    }, [
        stage,
        tree,
        waitingQueue
    ]);
    const process = async (stage, tree, performance)=>{
        onPerformance(true);
        const { userPayload: userPayload = {}, botPayload: botPayload = {}, systemPayload: systemPayload, behavior: behavior = {} } = stage;
        const { step: step } = performance;
        // check if we need to clear userPayload (entry or step type is clear)
        let isToClearUserPayload = false;
        const { type: type, action: action } = tree[step] || {};
        if (step === (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepForSystem.ENTRY || type === (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.CLEAR) isToClearUserPayload = true;
        setStage((prev)=>{
            const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(prev);
            (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "behavior.currentActor", $2807b35e372d459e$var$CHARACTER);
            // clear sCodes, input
            if (isToClearUserPayload) {
                delete _v.userPayload;
                delete _v.botPayload;
                delete _v.systemPayload;
            } else {
                const currentPayload = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).get(_v, "userPayload", {});
                // process all step object special fields (redirect url, fixed variables, etc)
                const _userPayload = onProcessPayload(tree[step], currentPayload);
                (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "userPayload", _userPayload);
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "currentStep", step);
            if (action) (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "nextStep", action);
            return _v;
        });
        /*
    === 
    fill in the panel. must be after onPerformance because async. 
    If we call onPerformance after it, before the API finish, system thinks its not picked, then task can be picked again
    === 
    */ switch(type){
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.RESULTS:
                // show panel, get id, then fill the panel with data
                const slId = onSpeakLine($2807b35e372d459e$var$CHARACTER, {
                    isMessageLoading: true
                }, type);
                try {
                    const res = await onFetchResults(userPayload) || null;
                    onSpeakLine($2807b35e372d459e$var$CHARACTER, {
                        data: res
                    }, type, slId);
                } catch (error) {
                    /* 
          NOTE: 
          because its not a global level error, its only invalid content
          so we treat it as part of conversation. show in system bubble, not throwing to StageManager
          */ const message = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).get(error, "response.data.message", "An error occurred");
                    onSpeakLine($2807b35e372d459e$var$CHARACTER, {
                        errorMessage: message.toString()
                    }, type, slId);
                }
                break;
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.SKIP:
            case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.CLEAR:
                break;
            default:
                break;
        }
        onPerformance(false);
    };
};
var $2807b35e372d459e$export$2e2bcd8739ae039 = $2807b35e372d459e$var$useSystem;



var $8NFma = parcelRequire("8NFma");
parcelRequire("O6tRJ");


const $7b3df785d558ac12$var$CHARACTER = (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.STAGEMANAGER;
/**
 * passively listens for stage changes
 * @param {*} props
 */ const $7b3df785d558ac12$var$useBot = (props)=>{
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage, onToastSpeakLine: onToastSpeakLine, onSpeakLine: onSpeakLine } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    (0, $8NFma.useEffect)(()=>{
        if (errorMessage) {
            // onToastSpeakLine(CHARACTER, { ...errorMessage }, '', {
            //   callback: () => setErrorMessage(null),
            //   delay: 3000
            // })
            onSpeakLine($7b3df785d558ac12$var$CHARACTER, {
                ...errorMessage
            });
            setErrorMessage(null);
        }
    }, [
        errorMessage
    ]);
};
var $7b3df785d558ac12$export$2e2bcd8739ae039 = $7b3df785d558ac12$var$useBot;


const $c1a19c3b921ee155$export$3a739ea0fb83fd37 = /*#__PURE__*/ (0, $8NFma.createContext)(null);
const $c1a19c3b921ee155$var$initStage = {
    nextStep: "ENTRY"
};
const $c1a19c3b921ee155$export$62bbd162148b4b86 = ({ className: className, children: children, onProcessPayload: onProcessPayload = ()=>{
    return null;
}, ...props })=>{
    const { tree: tree, labels: labels } = props;
    // for first load. then we clamp it to the context
    // to store halting parameters
    const [stage, setStage] = (0, $8NFma.useState)($c1a19c3b921ee155$var$initStage);
    // whenever its empty, director will step in to assign the next actor
    const [waitingQueue, setWaitingQueue] = (0, $8NFma.useState)([]);
    // to store history speaklines
    const [dialogueHistory, setDialogueHistory] = (0, $8NFma.useState)([]);
    const [errorMessage, setErrorMessage] = (0, $8NFma.useState)(null);
    const generateUniqueId = $c1a19c3b921ee155$var$useUniqueId();
    (0, $8NFma.useEffect)(()=>{
        clear();
    }, [
        tree
    ]);
    (0, $8NFma.useEffect)(()=>{
        console.log("dialogueHistory", dialogueHistory);
    }, [
        dialogueHistory
    ]);
    const onSpeakLine = (character = "SYSTEM", message, stepType, slId)=>{
        // message can be string or object
        // { data, errorMessage, isMessageLoading , chatMessage }
        const speakLine = {
            message: message,
            type: stepType,
            step: stage?.currentStep,
            character: character
        };
        const _newSlId = generateUniqueId();
        // if slId is provided, then update the existing message
        if (slId) setDialogueHistory((prev)=>{
            const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(prev);
            const _idx = _v.findIndex((item)=>item.slId === slId);
            if (_idx >= 0) {
                _v[_idx] = {
                    slId: slId,
                    ...speakLine
                };
                return _v;
            } else return prev;
        });
        else {
            speakLine.slId = _newSlId;
            setDialogueHistory((prev)=>[
                    ...prev,
                    speakLine
                ]);
            return _newSlId;
        }
    };
    const onToastSpeakLine = (character = "SYSTEM", message, stepType, options = {})=>{
        const { callback: callback, delay: delay } = options;
        // speakLine then auto remove after 5 seconds
        const slId = onSpeakLine(character, message, stepType);
        setTimeout(()=>{
            if (callback) callback();
            onCancelSpeakLine(slId);
        }, delay || 3000);
    };
    const onCancelSpeakLine = (slId)=>{
        setDialogueHistory((prev)=>{
            const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(prev);
            const _idx = _v.findIndex((item)=>item.slId === slId);
            if (_idx >= 0) _v.splice(_idx, 1);
            return _v;
        });
    };
    const onError = (chatMessage, messageType = "error")=>{
        setErrorMessage({
            chatMessage: chatMessage,
            messageType: messageType
        });
    };
    // ============ start: queue flow ============
    /*
    its very important for the flow. It will have endless loop if not handled properly
    the onPerformance is the stopper of the loop. so every schedule should have onPerformance

    onClaimPerformance is to check if the actor is the one who can claim the performance
    both onClaimPerformance and onPerformance only work on the first object in the queue. (no "cut in the line")
    Reason we split to 2 functions: when its User role, after claim, we need it stop to wait for user input.
  */ const onSchedulePerformanceList = (...performanceList)=>{
        setWaitingQueue((prev)=>[
                ...prev,
                ...performanceList
            ]);
    };
    const onClaimPerformance = (character = "")=>{
        // if list is empty, return false
        if ((0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).isEmpty(waitingQueue)) return false;
        /* 
      check if current actor is the one who can claim the performance 
      matches character, and not halted (prevent same actor claim twice due to async)
    */ const _firstPfmc = waitingQueue[0];
        if (_firstPfmc?.character !== character || _firstPfmc?.isHalt) return false;
        return _firstPfmc;
    };
    const onPerformance = (isHalt = false)=>{
        setWaitingQueue((prev)=>{
            const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(prev);
            if (_v?.length > 0) {
                if (isHalt) // in case we want to wait for further action
                _v[0].isHalt = isHalt;
                else _v.shift();
            }
            return _v;
        });
    };
    // ============ end: queue flow ============
    const clear = async ()=>{
        // primary trigger when first load or language/country change
        setStage($c1a19c3b921ee155$var$initStage);
        setDialogueHistory([]);
        setWaitingQueue([]);
    };
    const contextData = {
        ...props,
        labels: // init data
        labels,
        stage: // stage management
        stage,
        setStage: setStage,
        dialogueHistory: dialogueHistory,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage,
        onSpeakLine: // actions
        onSpeakLine,
        onCancelSpeakLine: onCancelSpeakLine,
        onToastSpeakLine: onToastSpeakLine,
        onProcessPayload: onProcessPayload,
        onSchedulePerformanceList: // for director assignment
        onSchedulePerformanceList,
        onClaimPerformance: onClaimPerformance,
        onPerformance: onPerformance,
        onError: onError,
        waitingQueue: waitingQueue
    };
    // control process
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: className,
        style: {
            direction: tree?.direction
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($c1a19c3b921ee155$export$3a739ea0fb83fd37.Provider, {
            value: {
                ...contextData
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($c1a19c3b921ee155$var$HooksWrapper, {}),
                children
            ]
        })
    });
};
// a wrapper to include all hooks
const $c1a19c3b921ee155$var$HooksWrapper = ()=>{
    (0, $3cedcce6badbf08d$export$2e2bcd8739ae039)();
    (0, $73d96a00ab44ec17$export$2e2bcd8739ae039)();
    (0, $2807b35e372d459e$export$2e2bcd8739ae039)();
    (0, $7b3df785d558ac12$export$2e2bcd8739ae039)();
    return null;
};
const $c1a19c3b921ee155$var$useUniqueId = ()=>{
    // Initialize a ref to hold the counter value
    const counterRef = (0, $8NFma.useRef)(0);
    // Function to generate a unique ID
    const generateUniqueId = ()=>{
        // Increment the counter
        counterRef.current += 1;
        // Combine the current slId with the counter value
        const uniqueId = `${Date.now()}-${counterRef.current}`;
        return uniqueId;
    };
    return generateUniqueId;
};




var $O6tRJ = parcelRequire("O6tRJ");


/**
 * original purpose is to update sCodes with AND/OR/NOTEXISTS logics
 * then we extend it to update input values
 * then we extend it to redirect to external url
 * @param {*} payloadUpdator
 * @param {*} currentPayload
 * @returns
 */ const $cc5aa301cdd3eb9a$var$processPayload = (payloadUpdator, currentPayload)=>{
    if (!payloadUpdator) return;
    const { redirect_url: // === special action ===
    redirect_url, values: // === variables we want to update ===
    values, scode: scode, scode_method: // === the way we update variables ===
    scode_method = (0, $b2e6864aad7029da$export$2e2bcd8739ae039).scodeMethods.default, operation: operation = (0, $b2e6864aad7029da$export$2e2bcd8739ae039).operations.default // <work with scode> [AND, OR, NOTEXISTS]
     } = payloadUpdator;
    if (redirect_url) window.open(option.redirect_url, "_blank");
    const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(currentPayload) || {};
    // add parameters
    let bucket = "sCodes";
    switch(operation){
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).operations.OR:
            bucket = "sCodes_or";
            break;
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).operations.NOTEXISTS:
            bucket = "sCodes_notexists";
            break;
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).operations.AND:
            bucket = "sCodes";
            break;
        default:
            bucket = "sCodes";
            break;
    }
    let currentSCodes = _v[bucket] || [];
    switch(scode_method){
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).scodeMethods.REPLACE:
            currentSCodes = typeof scode === "string" ? [
                scode
            ] : scode;
            break;
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).scodeMethods.ATTACH:
        default:
            // for scode: add scode to the string array, if not already there
            if (scode && !currentSCodes.includes(scode)) currentSCodes.push(scode);
            break;
    }
    _v[bucket] = currentSCodes;
    /*
    for values: (values is updator, _v.input is original)
    1. if its {}, delete it
    2. if it has key-value pair and value is not empty, override original value
    3. if it has key-value pair and value is empty, delete original value
  */ if (typeof values === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).isEmpty(values)) (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).unset(_v, "input");
    else if (typeof values === "object") (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).keys(values).forEach((k)=>{
        if (values[k]) (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, `input.${k}`, values[k]);
        else (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).unset(_v, `input.${k}`);
    });
    return _v;
};
const $cc5aa301cdd3eb9a$var$extractPhone = (mix)=>{
    if (!mix) return "";
    // let numb = mix.match(/\d/g);
    let numb = mix.match(/\+|\d/g);
    numb = numb?.join("") || "";
    return numb;
};
const $cc5aa301cdd3eb9a$export$6cd0ad0b58f1df74 = (step, k)=>{
    const { question: question, options: options, action: action, type: type, ...rest } = step;
    switch(type){
        case "SKIP":
        case "CLEAR":
            if (!action) console.error(`${k}: action is required`);
            break;
        case "LOC_ZIP":
            if (!question) console.error(`${k}: question is required`);
            if (!action) console.error(`${k}: action is required`);
            break;
        case "RESULTS":
            if (!question) console.error(`${k}: question is required`);
            if (!action) console.error(`${k}: action is required`);
            break;
        case "OPTIONS_ONLY":
            if (!options) console.error(`${k}: options is required`);
            break;
        case "OPTIONS":
        default:
            if (!options) console.error(`${k}: options is required`);
            if (!question) console.error(`${k}: question is required`);
            break;
    }
};
const $cc5aa301cdd3eb9a$export$43acca5f63cae29d = {
    US: {
        regex: "^[0-9]{5}(-[0-9]{4})?$",
        message: "Please enter a valid US zip code"
    },
    ID: {
        regex: "^\\d{5}$",
        message: "Please enter a valid ID zip code"
    },
    PH: {
        regex: "^\\d{4}$",
        message: "Please enter a valid PH zip code"
    }
};
const $cc5aa301cdd3eb9a$export$f5e7b3c13453285 = (link)=>{
    const reg = new RegExp("^(?:[a-z]+:)?//", "i");
    if (link?.toLowerCase().lastIndexOf(".pdf") != -1) return (0, $b2e6864aad7029da$export$4cea97e757f1b48b).PDF;
    if (link?.toLowerCase().indexOf("mailto:") === 0) return (0, $b2e6864aad7029da$export$4cea97e757f1b48b).MAIL;
    if (link?.toLowerCase().indexOf("tel:") === 0) return (0, $b2e6864aad7029da$export$4cea97e757f1b48b).PHONE;
    else if (reg.test(link)) return (0, $b2e6864aad7029da$export$4cea97e757f1b48b).EXTERNAL;
    else if (link?.indexOf("/") === 0) return (0, $b2e6864aad7029da$export$4cea97e757f1b48b).ABSOLUTE;
    else return (0, $b2e6864aad7029da$export$4cea97e757f1b48b).RELATIVE;
};
var $cc5aa301cdd3eb9a$export$2e2bcd8739ae039 = {
    extractPhone: $cc5aa301cdd3eb9a$var$extractPhone,
    regexForZips: $cc5aa301cdd3eb9a$export$43acca5f63cae29d,
    processPayload: $cc5aa301cdd3eb9a$var$processPayload
};


const $f8afb0169f3a1369$export$ae9a8eaefa5810ed = /*#__PURE__*/ (0, $8NFma.createContext)(null);
// we leave it empty so that server can detect from IP. real default county set from server because for country we need IP detection
const $f8afb0169f3a1369$var$DEFAULT_COUNTRY = "";
const $f8afb0169f3a1369$var$DEFAULT_LANGUAGE = "en-US";
const $f8afb0169f3a1369$var$cookieLang = localStorage.getItem("rivara_currentLanguage") || "";
const $f8afb0169f3a1369$var$cookieCountry = localStorage.getItem("rivara_currentCountry") || "";
const $f8afb0169f3a1369$export$a2d7bc907bed8095 = ({ className: className, initAccessCode: initAccessCode = "", initLanguage: initLanguage = "", initCountry: initCountry = "", initUserAvatar: initUserAvatar = "", initZIndex: initZIndex = "", initCookieOff: initCookieOff = false, initIsPreview: initIsPreview = false, children: children, customLanguage: // ==== custom updates from outside ====
customLanguage = "", customCountry: customCountry = "", customAccessCode: customAccessCode = "", customUserAvatar: customUserAvatar = "", customCookieOff: customCookieOff = false, triggerer: triggerer = "", show: show, setShow: setShow })=>{
    // passed in
    const [language, setLanguage] = (0, $8NFma.useState)(initLanguage || $f8afb0169f3a1369$var$cookieLang || $f8afb0169f3a1369$var$DEFAULT_LANGUAGE);
    const [country, setCountry] = (0, $8NFma.useState)(initCountry || $f8afb0169f3a1369$var$cookieCountry || $f8afb0169f3a1369$var$DEFAULT_COUNTRY);
    const [accessCode, setAccessCode] = (0, $8NFma.useState)(initAccessCode);
    const [userAvatar, setUserAvatar] = (0, $8NFma.useState)(initUserAvatar);
    const [zIndex, setZIndex] = (0, $8NFma.useState)(initZIndex);
    const [cookieOff, setCookieOff] = (0, $8NFma.useState)(initCookieOff);
    const isPreview = initIsPreview === "true" || initIsPreview === true || initIsPreview === "1" || initIsPreview === 1;
    // for first load. then we clamp it to the context
    const [labels, setLabels] = (0, $8NFma.useState)({});
    const [loaded, setLoaded] = (0, $8NFma.useState)(false);
    const [globalErrorMessage, setGlobalErrorMessage] = (0, $8NFma.useState)(null);
    const [tree, setTree] = (0, $8NFma.useState)(null);
    const [token, setToken] = (0, $8NFma.useState)(null);
    const [client, setClient] = (0, $8NFma.useState)(null);
    const [languageList, setLanguageList] = (0, $8NFma.useState)([]);
    const [countryList, setCountryList] = (0, $8NFma.useState)([]);
    const [visitorId, setVisitorId] = (0, $8NFma.useState)("");
    const [direction, setDirection] = (0, $8NFma.useState)("ltr");
    // {org_id: 20369}
    const [showFacility, setShowFacility] = (0, $8NFma.useState)(null);
    // UI
    const [uiDrawer, setUiDrawer] = (0, $8NFma.useState)("");
    // only used once. to record visitor when first open the chatbox
    const [hasRecordedVisitor, setHasRecordedVisitor] = (0, $8NFma.useState)(false);
    const zIndexInt = parseInt(zIndex) || 1000000;
    (0, $8NFma.useEffect)(()=>{
        if (accessCode) // validate access code
        initClient(accessCode);
    }, [
        accessCode
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (token && language && country) // read tree and translations
        initRivara(token, language, country);
    }, [
        token,
        language,
        country
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (token && show && !hasRecordedVisitor) // only used once. to record visitor when first open the chatbox
        initVisitor(token);
    }, [
        token,
        show,
        hasRecordedVisitor
    ]);
    // ============= custom updates from outside =============
    (0, $8NFma.useEffect)(()=>{
        if (customAccessCode || customLanguage) {
            setAccessCode(customAccessCode);
            setLanguage(customLanguage);
            setCountry(customCountry);
        }
    }, [
        customAccessCode,
        customLanguage,
        customCountry,
        triggerer
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (customUserAvatar) setUserAvatar(customUserAvatar);
    }, [
        customUserAvatar,
        triggerer
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (customCookieOff) setCookieOff(customCookieOff);
    }, [
        customCookieOff,
        triggerer
    ]);
    // ============= custom updates from outside =============
    const onSwitchLanguage = async (lang)=>{
        setLanguage(lang);
        setUiDrawer("");
    };
    const onSwitchCountry = async (country)=>{
        setCountry(country);
        setUiDrawer("");
    };
    const onException = (chatMessage, messageType = "error")=>{
        setGlobalErrorMessage({
            chatMessage: chatMessage,
            messageType: messageType
        });
    };
    async function initClient(accessCode) {
        setGlobalErrorMessage(null);
        setLoaded(false);
        try {
            // init client by token
            const res = await (0, $726aa11b12c82653$export$2e2bcd8739ae039).getToken(accessCode);
            if (res?.invalid) throw new Error(res?.messages);
            setToken(res.token);
            setClient(res.client);
            // init settings: language list, country list, detected country if empty
            const { languageList: languageList, countryList: countryList, ipCountry: ipCountry } = await (0, $726aa11b12c82653$export$2e2bcd8739ae039).getSettings(res.token, $f8afb0169f3a1369$var$cookieLang, $f8afb0169f3a1369$var$cookieCountry, {
                isPreview: isPreview
            });
            setLanguageList(languageList || []);
            setCountryList(countryList || []);
            if (ipCountry) setCountry(ipCountry);
        } catch (err) {
            onException(err?.message);
        } finally{
            setLoaded(true);
        }
    }
    async function initRivara(token, lang, country) {
        setGlobalErrorMessage(null);
        setLoaded(false);
        try {
            // get the tree
            const data = await (0, $726aa11b12c82653$export$2e2bcd8739ae039).getTree(token, lang, country, {
                cookieOff: cookieOff,
                isPreview: isPreview
            });
            if (!data?.logicTree) throw new Error(labels["lbl_Error_LostConnection"] || "Oops, we lost connection to the server. Please try again later.");
            setTree(data?.logicTree);
            setLabels(data?.labels);
            setDirection(data?.direction || "ltr");
        } catch (err) {
            onException(err?.message);
        } finally{
            setLoaded(true);
        }
    }
    async function initVisitor(token) {
        try {
            // get visitor_token
            let visitor_token = localStorage.getItem("visitor_token") || "";
            // if we dont turn off cookie, and we dont have token. means new visitor
            if (!cookieOff && !visitor_token) visitor_token = "new";
            const visitor = await (0, $726aa11b12c82653$export$2e2bcd8739ae039).recordVisitor({
                visitor_token: visitor_token,
                accesstoken: token,
                isPreview: isPreview
            });
            // store visitor
            if (visitor?.visitor_token && !cookieOff) localStorage.setItem("visitor_token", visitor?.visitor_token);
            if (visitor?.visitor_id) setVisitorId(visitor?.visitor_id);
            setHasRecordedVisitor(true);
        } catch (err) {
            console.error("recordVisitor", err);
        } finally{}
    }
    const onProcessPayload = (0, $cc5aa301cdd3eb9a$export$2e2bcd8739ae039).processPayload;
    const onFetchResults = async (payload)=>{
        const res = await (0, $726aa11b12c82653$export$2e2bcd8739ae039).getResults(token, {
            ...payload,
            lang: language,
            country: country
        }, {
            isPreview: isPreview
        });
        return res;
    };
    const contextData = {
        tree: // init data
        tree,
        globalErrorMessage: globalErrorMessage,
        setGlobalErrorMessage: setGlobalErrorMessage,
        labels: labels,
        languageList: languageList,
        countryList: countryList,
        language: language,
        country: country,
        userAvatar: userAvatar,
        showFacility: showFacility,
        setShowFacility: setShowFacility,
        direction: direction,
        uiDrawer: uiDrawer,
        setUiDrawer: setUiDrawer,
        show: show,
        setShow: setShow,
        isPreview: isPreview,
        onSwitchLanguage: onSwitchLanguage,
        onSwitchCountry: onSwitchCountry,
        onProcessPayload: onProcessPayload,
        onException: onException,
        onFetchResults: onFetchResults,
        zIndex: zIndexInt,
        client: client,
        token: token,
        visitorId: visitorId,
        loaded: loaded
    };
    if (!accessCode) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        style: {
            display: "none"
        },
        children: "Rivara: no access code"
    });
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($f8afb0169f3a1369$export$ae9a8eaefa5810ed.Provider, {
        value: {
            ...contextData
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c1a19c3b921ee155$export$62bbd162148b4b86), {
            ...contextData,
            children: children
        })
    });
};




var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");
var $f8c99c41bd600645$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $f8c99c41bd600645$exports) {
        classNames.default = classNames;
        $f8c99c41bd600645$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $8NFma = parcelRequire("8NFma");
const $0ea84f440c4091a4$var$useScrollbarOffset = ()=>{
    const [style, setStyle] = (0, $8NFma.useState)({
        "--offset-scrollbar": "0px"
    });
    const [wasScrollbarVisible, setWasScrollbarVisible] = (0, $8NFma.useState)(null);
    (0, $8NFma.useEffect)(()=>{
        const calculateScrollbarWidth = ()=>{
            const outer = document.createElement("div");
            outer.style.visibility = "hidden";
            outer.style.overflow = "scroll";
            outer.style.width = "50px";
            outer.style.height = "50px";
            document.body.appendChild(outer);
            const inner = document.createElement("div");
            inner.style.width = "100%";
            outer.appendChild(inner);
            const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
            outer.parentNode.removeChild(outer);
            return scrollbarWidth;
        };
        const updateStyle = ()=>{
            const scrollbarVisible = window.innerWidth > document.documentElement.clientWidth;
            const scrollbarWidth = calculateScrollbarWidth();
            if (wasScrollbarVisible === null) // First render, set initial style
            setWasScrollbarVisible(scrollbarVisible);
            else if (wasScrollbarVisible && !scrollbarVisible) // Scrollbar was visible, now it's not
            setStyle({
                "--offset-scrollbar": `${scrollbarWidth}px`
            });
            else if (!wasScrollbarVisible && scrollbarVisible) // Scrollbar was not visible, now it is
            setStyle({
                "--offset-scrollbar": "0px"
            });
            setWasScrollbarVisible(scrollbarVisible);
        };
        updateStyle();
        const resizeObserver = new ResizeObserver(()=>{
            updateStyle();
        });
        resizeObserver.observe(document.documentElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        wasScrollbarVisible
    ]);
    return style;
};
var $0ea84f440c4091a4$export$2e2bcd8739ae039 = $0ea84f440c4091a4$var$useScrollbarOffset;




var $8NFma = parcelRequire("8NFma");
parcelRequire("O6tRJ");




var $8NFma = parcelRequire("8NFma");





var $8NFma = parcelRequire("8NFma");


var $0eed5f300391f9fe$exports = {};

$0eed5f300391f9fe$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "ari_minimized.8b220e5a.webp";


var $1c581638efd95a3c$export$345c5736c8054f22;
var $1c581638efd95a3c$export$f5dbf5ce556e97fb;
var $1c581638efd95a3c$export$3042ce2e3836ba7f;
var $1c581638efd95a3c$export$114dbff7fb2bf04f;
$1c581638efd95a3c$export$345c5736c8054f22 = `ed83XW_avatar`;
$1c581638efd95a3c$export$f5dbf5ce556e97fb = `ed83XW_bubble`;
$1c581638efd95a3c$export$3042ce2e3836ba7f = `ed83XW_bubbleContainer`;
$1c581638efd95a3c$export$114dbff7fb2bf04f = `ed83XW_scaleUp`;
$1c581638efd95a3c$export$114dbff7fb2bf04f;



const $8bb40800d9add1cd$export$c25e0f8cca6c69a3 = ({ message: message, type: type, idx: idx, ...props })=>{
    const { chatMessage: chatMessage } = message || {};
    switch(type){
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).messageTypes.HTMLPANEL:
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($8bb40800d9add1cd$var$BubbleHtml, {
                message: chatMessage
            });
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).messageTypes.BUBBLE:
        default:
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($8bb40800d9add1cd$var$BubbleWithAvatar, {
                message: chatMessage
            });
    }
};
const $8bb40800d9add1cd$var$BubbleWithAvatar = ({ message: message })=>{
    const { client: //
    client } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const clientChatAvatar = client?.client_chat_avatar ? `${client?.client_chat_avatar}?v=${client.updatedAt}` : (0, (/*@__PURE__*/$parcel$interopDefault($0eed5f300391f9fe$exports)));
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($1c581638efd95a3c$export$3042ce2e3836ba7f),
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($1c581638efd95a3c$export$345c5736c8054f22),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    src: clientChatAvatar,
                    alt: "avatar"
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($1c581638efd95a3c$export$f5dbf5ce556e97fb),
                dangerouslySetInnerHTML: {
                    __html: message
                }
            })
        ]
    });
};
const $8bb40800d9add1cd$var$BubbleHtml = ({ message: message })=>{
    // TODO: add html panel css
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: message
        }
    });
};
var $8bb40800d9add1cd$export$2e2bcd8739ae039 = $8bb40800d9add1cd$export$c25e0f8cca6c69a3;




var $8NFma = parcelRequire("8NFma");


var $f91dc7d291e02aec$exports = {};

$f91dc7d291e02aec$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "no-avatar.ed99f9d0.webp";


var $5e86cd92f6c51c0d$export$345c5736c8054f22;
var $5e86cd92f6c51c0d$export$f5dbf5ce556e97fb;
var $5e86cd92f6c51c0d$export$3042ce2e3836ba7f;
var $5e86cd92f6c51c0d$export$114dbff7fb2bf04f;
$5e86cd92f6c51c0d$export$345c5736c8054f22 = `C-xsua_avatar`;
$5e86cd92f6c51c0d$export$f5dbf5ce556e97fb = `C-xsua_bubble`;
$5e86cd92f6c51c0d$export$3042ce2e3836ba7f = `C-xsua_bubbleContainer`;
$5e86cd92f6c51c0d$export$114dbff7fb2bf04f = `C-xsua_scaleUp`;
$5e86cd92f6c51c0d$export$114dbff7fb2bf04f;


const $02fc6b22cf5a8d25$export$c25e0f8cca6c69a3 = ({ message: message = {}, step: step, idx: idx, ...props })=>{
    const {} = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const { chatMessage: chatMessage } = message || {};
    let displayMessage = "";
    switch(typeof chatMessage){
        case "string":
            displayMessage = chatMessage;
            break;
        case "function":
            displayMessage = chatMessage();
            break;
        default:
            displayMessage = "No message";
            break;
    }
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($02fc6b22cf5a8d25$var$BubbleWithAvatar, {
        message: displayMessage
    });
};
const $02fc6b22cf5a8d25$var$BubbleWithAvatar = ({ message: message })=>{
    const { userAvatar: //
    userAvatar } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($5e86cd92f6c51c0d$export$3042ce2e3836ba7f),
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($5e86cd92f6c51c0d$export$f5dbf5ce556e97fb),
                dangerouslySetInnerHTML: {
                    __html: message
                }
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($5e86cd92f6c51c0d$export$345c5736c8054f22),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    src: userAvatar || (0, (/*@__PURE__*/$parcel$interopDefault($f91dc7d291e02aec$exports)))
                })
            })
        ]
    });
};
var $02fc6b22cf5a8d25$export$2e2bcd8739ae039 = $02fc6b22cf5a8d25$export$c25e0f8cca6c69a3;




var $8NFma = parcelRequire("8NFma");
parcelRequire("O6tRJ");





var $8NFma = parcelRequire("8NFma");

var $581a518146acd46a$exports = {};

$581a518146acd46a$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "default_logo.f363ad9a.png";


var $a6a6b7085ef35258$exports = {};

$a6a6b7085ef35258$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "hotline_thumbnail.18d57565.webp";


var $4fe9aefd4efd98c4$exports = {};

$4fe9aefd4efd98c4$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "warmline_thumbnail.53790628.webp";


var $9c56ec495af1a0da$exports = {};

$9c56ec495af1a0da$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "sms_hotline_thumbnail.540ae242.webp";


var $143e99fc019fb4ac$exports = {};

$143e99fc019fb4ac$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "sms_warmline_thumbnail.4552537a.webp";


var $2dee8c321953b761$exports = {};

$2dee8c321953b761$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "phone-solid-white.2cd74882.svg";


var $1a831fb0fec97edd$exports = {};

$1a831fb0fec97edd$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "global-white.40787e15.svg";


var $80ed353b4799b231$exports = {};

$80ed353b4799b231$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "message-bubble-white.5cdd0a77.svg";



var $8NFma = parcelRequire("8NFma");


function $1f43aaaca7086c0e$var$useEngagement(onClick) {
    const { client: client, token: token, visitorId: visitorId, language: language, isPreview: isPreview } = (0, $8NFma.useContext)((0, $f8afb0169f3a1369$export$ae9a8eaefa5810ed));
    return (0, $8NFma.useCallback)((recordType, id, link)=>{
        return (e)=>{
            // record engagement
            const activity_type = recordType;
            const activity_code = [
                id,
                link
            ].filter((a)=>a).join("::");
            const o = {
                visitor_id: visitorId,
                activity_type: activity_type,
                activity_code: activity_code,
                language: language,
                isPreview: // country,
                isPreview
            };
            // dont await (to speed up)
            (0, $726aa11b12c82653$export$2e2bcd8739ae039).recordEngagement(o);
            if (onClick) onClick(e);
        };
    }, [
        onClick
    ]);
}
var $1f43aaaca7086c0e$export$2e2bcd8739ae039 = $1f43aaaca7086c0e$var$useEngagement;






var $633e69fa81ff7bad$export$f2120bbfa5450bd2;
var $633e69fa81ff7bad$export$aa3e815946b80764;
var $633e69fa81ff7bad$export$1c666b61ec7d376;
var $633e69fa81ff7bad$export$8ecea116bb7ce8ab;
var $633e69fa81ff7bad$export$13a2d28b88853ef2;
var $633e69fa81ff7bad$export$4e6856be2fa35dca;
var $633e69fa81ff7bad$export$a3bc9b8ed74fc;
var $633e69fa81ff7bad$export$adb608be33961c98;
var $633e69fa81ff7bad$export$73920f18ca706874;
var $633e69fa81ff7bad$export$1ca1ec8b29a4ce27;
var $633e69fa81ff7bad$export$df03f54e09e486fa;
var $633e69fa81ff7bad$export$17a1664ed1fb5d6f;
var $633e69fa81ff7bad$export$29725192708d9349;
var $633e69fa81ff7bad$export$6dd7c7168fc9f148;
var $633e69fa81ff7bad$export$17aca76bf89ef49e;
var $633e69fa81ff7bad$export$3cbbe2f4ae007ac0;
var $633e69fa81ff7bad$export$a61973c5dd786949;
var $633e69fa81ff7bad$export$9eb297cdc7a32c58;
var $633e69fa81ff7bad$export$321269ced4b4fd0a;
var $633e69fa81ff7bad$export$114dbff7fb2bf04f;
var $633e69fa81ff7bad$export$31058511a46edb1e;
var $633e69fa81ff7bad$export$3a4645bd1009de65;
var $633e69fa81ff7bad$export$f4ef0350860caa52;
var $633e69fa81ff7bad$export$d35f6a9f0135f711;
var $633e69fa81ff7bad$export$fb184b623420d9be;
var $633e69fa81ff7bad$export$1e95b668f3b82d;
$633e69fa81ff7bad$export$f2120bbfa5450bd2 = `_5tCNTW_arrow`;
$633e69fa81ff7bad$export$aa3e815946b80764 = `_5tCNTW_card`;
$633e69fa81ff7bad$export$1c666b61ec7d376 = `_5tCNTW_cardContentContainer`;
$633e69fa81ff7bad$export$8ecea116bb7ce8ab = `_5tCNTW_defaultCard`;
$633e69fa81ff7bad$export$13a2d28b88853ef2 = `_5tCNTW_detail`;
$633e69fa81ff7bad$export$4e6856be2fa35dca = `_5tCNTW_detailContainer`;
$633e69fa81ff7bad$export$a3bc9b8ed74fc = `_5tCNTW_error`;
$633e69fa81ff7bad$export$adb608be33961c98 = `_5tCNTW_footer`;
$633e69fa81ff7bad$export$73920f18ca706874 = `_5tCNTW_hidden`;
$633e69fa81ff7bad$export$1ca1ec8b29a4ce27 = `_5tCNTW_icon`;
$633e69fa81ff7bad$export$df03f54e09e486fa = `_5tCNTW_icons`;
$633e69fa81ff7bad$export$17a1664ed1fb5d6f = `_5tCNTW_items`;
$633e69fa81ff7bad$export$29725192708d9349 = `_5tCNTW_logo_container`;
$633e69fa81ff7bad$export$6dd7c7168fc9f148 = `_5tCNTW_logo_image`;
$633e69fa81ff7bad$export$17aca76bf89ef49e = `_5tCNTW_noResult`;
$633e69fa81ff7bad$export$3cbbe2f4ae007ac0 = `_5tCNTW_overlayBadge`;
$633e69fa81ff7bad$export$a61973c5dd786949 = `_5tCNTW_overlayTitle`;
$633e69fa81ff7bad$export$9eb297cdc7a32c58 = `_5tCNTW_phonesCard`;
$633e69fa81ff7bad$export$321269ced4b4fd0a = `_5tCNTW_phonesTitle`;
$633e69fa81ff7bad$export$114dbff7fb2bf04f = `_5tCNTW_scaleUp`;
$633e69fa81ff7bad$export$31058511a46edb1e = `_5tCNTW_showMoreButton`;
$633e69fa81ff7bad$export$3a4645bd1009de65 = `_5tCNTW_smsCard`;
$633e69fa81ff7bad$export$f4ef0350860caa52 = `_5tCNTW_smsTitle`;
$633e69fa81ff7bad$export$d35f6a9f0135f711 = `_5tCNTW_tapButton`;
$633e69fa81ff7bad$export$fb184b623420d9be = `_5tCNTW_title`;
$633e69fa81ff7bad$export$1e95b668f3b82d = `_5tCNTW_top`;


parcelRequire("8NFma");

parcelRequire("O6tRJ");
const $85a1be93bd0bcb9d$var$Hook = ()=>{
    const getImage = (fileName, type = "facilities")=>{
        if (!fileName) return null;
        return `${(0, $726aa11b12c82653$export$2e2bcd8739ae039).CND_SERVER}/images/${type}/${fileName}`;
    };
    return {
        getImage: getImage
    };
};
var $85a1be93bd0bcb9d$export$2e2bcd8739ae039 = $85a1be93bd0bcb9d$var$Hook;


const $759f37b5c33ecdfa$var$PER_PAGE = 4;
const $759f37b5c33ecdfa$var$CARD_WIDTH = 190;
const $759f37b5c33ecdfa$var$TEXT_CONTAINER_WIDTH = $759f37b5c33ecdfa$var$CARD_WIDTH - 60;
const $759f37b5c33ecdfa$var$Com = ({ data: data })=>{
    const { setShowFacility: setShowFacility, setUiDrawer: setUiDrawer, labels: labels } = (0, $8NFma.useContext)((0, $f8afb0169f3a1369$export$ae9a8eaefa5810ed));
    const results = data;
    const [error, setError] = (0, $8NFma.useState)();
    const [page, setPage] = (0, $8NFma.useState)(0);
    const handleOnClick = (fac)=>{
        setShowFacility(fac);
        setUiDrawer((0, $b2e6864aad7029da$export$2e2bcd8739ae039).drawers.facility);
    };
    const handleShowMore = ()=>{
        if (page * $759f37b5c33ecdfa$var$PER_PAGE >= results.length) return;
        setPage(page + 1);
    };
    // Return null since we don't want to render anything for this step
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$17a1664ed1fb5d6f),
        children: results.length > 0 ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
            children: [
                results.slice(0, (page + 1) * $759f37b5c33ecdfa$var$PER_PAGE).map((item, i)=>{
                    const { website: website, card_type: card_type, phone_hotline: phone_hotline, sms: sms, public_phone: public_phone } = item;
                    let CardWithType;
                    switch(card_type){
                        case "sms":
                            CardWithType = sms ? $759f37b5c33ecdfa$var$CardSMS : null;
                            break;
                        case "hotline":
                            // logic here: if there is no hotline, sms will be the priority
                            if (phone_hotline) CardWithType = $759f37b5c33ecdfa$var$CardHotline;
                            else if (sms) CardWithType = $759f37b5c33ecdfa$var$CardSMS;
                            break;
                        case "warmline":
                            if (phone_hotline) CardWithType = $759f37b5c33ecdfa$var$CardWarmline;
                            else if (sms) CardWithType = $759f37b5c33ecdfa$var$CardSMS;
                            break;
                        case "website":
                            CardWithType = website ? $759f37b5c33ecdfa$var$CardWebsite : null;
                            break;
                        case "phone":
                            CardWithType = $759f37b5c33ecdfa$var$CardPublicPhone;
                            break;
                        case "facility":
                            CardWithType = $759f37b5c33ecdfa$var$CardWebsite;
                        default:
                            // if its null. priority is website -> phone -> sms
                            if (website) CardWithType = $759f37b5c33ecdfa$var$CardWebsite;
                            else if (phone_hotline) CardWithType = $759f37b5c33ecdfa$var$CardHotline;
                            else if (public_phone) CardWithType = $759f37b5c33ecdfa$var$CardPublicPhone;
                            else if (sms) CardWithType = $759f37b5c33ecdfa$var$CardSMS;
                    }
                    // exception catch
                    // if there is no website, phone_hotline, sms, no matter what types its publich phone
                    if (!CardWithType) CardWithType = $759f37b5c33ecdfa$var$CardPublicPhone;
                    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(CardWithType, {
                            item: item,
                            labels: labels,
                            onClick: handleOnClick
                        })
                    }, item.org_id);
                }),
                (page + 1) * $759f37b5c33ecdfa$var$PER_PAGE < results.length ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$adb608be33961c98),
                    style: {
                        userSelect: "none"
                    },
                    onClick: handleShowMore,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$31058511a46edb1e),
                        children: [
                            labels["lbl_Remaining"] || "Remaining...",
                            " (",
                            Math.min((page + 1) * $759f37b5c33ecdfa$var$PER_PAGE, results.length),
                            " /",
                            " ",
                            results.length,
                            ")"
                        ]
                    })
                }) : null
            ]
        }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$17aca76bf89ef49e),
            children: labels["lbl_NoResults"] || "No results"
        })
    });
};
const $759f37b5c33ecdfa$var$CardWebsite = ({ labels: labels, item: item, onClick: onClick })=>{
    const { org_id: org_id, website: website, name1: name1, name2: name2, logo: logo, description: description, card_type: card_type } = item;
    const title = [
        name1 || "",
        name2 || ""
    ].join(" ");
    const { getImage: getImage } = (0, $85a1be93bd0bcb9d$export$2e2bcd8739ae039)();
    const handleRecord = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)(null)((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_WEBSITE, org_id, website);
    const handleRecordDetail = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)((item)=>{
        onClick(item);
    })((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_DETAIL, org_id);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$aa3e815946b80764, $633e69fa81ff7bad$export$8ecea116bb7ce8ab),
        style: {
            width: $759f37b5c33ecdfa$var$CARD_WIDTH
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$3cbbe2f4ae007ac0),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1a831fb0fec97edd$exports))),
                    alt: "website",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$1ca1ec8b29a4ce27)
                })
            }),
            website ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                onClick: handleRecord,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$1c666b61ec7d376),
                href: website,
                target: "_blank",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$29725192708d9349),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$a61973c5dd786949),
                            children: labels["lbl_VisitWebsite"] || "Visit Website"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$6dd7c7168fc9f148),
                            style: {
                                background: `url(${getImage(logo) || (0, (/*@__PURE__*/$parcel$interopDefault($581a518146acd46a$exports)))}) no-repeat center center`
                            }
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$4e6856be2fa35dca),
                onClick: ()=>{
                    handleRecordDetail(item);
                },
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$fb184b623420d9be),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$13a2d28b88853ef2),
                        children: labels["lbl_Details"] || "Details"
                    })
                ]
            })
        ]
    }, org_id);
};
const $759f37b5c33ecdfa$var$CardSMS = ({ labels: labels, item: item, onClick: onClick })=>{
    const { org_id: org_id, sms: sms, sms_msg: sms_msg, name1: name1, name2: name2, logo: logo, sms_details: sms_details, card_type: card_type } = item;
    const title = [
        name1 || "",
        name2 || ""
    ].join(" ");
    const { getImage: getImage } = (0, $85a1be93bd0bcb9d$export$2e2bcd8739ae039)();
    const _bg = card_type === "hotline" ? (0, (/*@__PURE__*/$parcel$interopDefault($9c56ec495af1a0da$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($143e99fc019fb4ac$exports)));
    const link = `sms:${(0, $cc5aa301cdd3eb9a$export$2e2bcd8739ae039).extractPhone(sms)}?body=${sms_msg}`;
    const handleRecord = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)(null)((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_SMS, org_id, link);
    const handleRecordDetail = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)((item)=>{
        onClick(item);
    })((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_DETAIL, org_id);
    const [fontSize, setFontSize] = (0, $8NFma.useState)("1em");
    const hiddenRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        const textWidth = hiddenRef.current.offsetWidth;
        // calculage the desired font size by textWidth and container width (CARD_WIDTH)
        const _fontSize = Math.min(2.5, $759f37b5c33ecdfa$var$TEXT_CONTAINER_WIDTH / textWidth) + "em";
        setFontSize(_fontSize);
    }, [
        sms
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$aa3e815946b80764, $633e69fa81ff7bad$export$3a4645bd1009de65),
        style: {
            width: $759f37b5c33ecdfa$var$CARD_WIDTH
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$3cbbe2f4ae007ac0),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($80ed353b4799b231$exports))),
                    alt: "sms",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$1ca1ec8b29a4ce27)
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                onClick: handleRecord,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$1c666b61ec7d376),
                href: link,
                target: "_blank",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$29725192708d9349),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$a61973c5dd786949),
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$73920f18ca706874),
                                    ref: hiddenRef,
                                    children: sms
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$f4ef0350860caa52),
                                    style: {
                                        fontSize: fontSize
                                    },
                                    children: sms
                                }),
                                sms_details ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    children: sms_details
                                }) : null,
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$d35f6a9f0135f711),
                                    children: labels["lbl_TapToMessageNow"] || "Tap to message now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$6dd7c7168fc9f148),
                            style: {
                                background: `url(${_bg}) no-repeat center center`
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$4e6856be2fa35dca),
                onClick: ()=>{
                    handleRecordDetail(item);
                },
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$fb184b623420d9be),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$13a2d28b88853ef2),
                        children: labels["lbl_Details"] || "Details"
                    })
                ]
            })
        ]
    }, org_id);
};
const $759f37b5c33ecdfa$var$CardHotline = ({ labels: labels, item: item, onClick: onClick })=>{
    const { org_id: org_id, phone_hotline: phone_hotline } = item;
    const link = `tel:${(0, $cc5aa301cdd3eb9a$export$2e2bcd8739ae039).extractPhone(phone_hotline)}`;
    const handleRecord = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)(null)((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_HOTLINE, org_id, link);
    const handleRecordDetail = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)((item)=>{
        onClick(item);
    })((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_DETAIL, org_id);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($759f37b5c33ecdfa$var$COM_CardPhones, {
        labels: labels,
        item: item,
        handleRecord: handleRecord,
        handleRecordDetail: handleRecordDetail,
        _link: link,
        _phone: phone_hotline,
        _bg: (0, (/*@__PURE__*/$parcel$interopDefault($a6a6b7085ef35258$exports)))
    });
};
const $759f37b5c33ecdfa$var$CardWarmline = ({ labels: labels, item: item, onClick: onClick })=>{
    const { org_id: org_id, phone_hotline: phone_hotline } = item;
    const link = `tel:${(0, $cc5aa301cdd3eb9a$export$2e2bcd8739ae039).extractPhone(phone_hotline)}`;
    const handleRecord = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)(null)((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_WARMLINE, org_id, link);
    const handleRecordDetail = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)((item)=>{
        onClick(item);
    })((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_DETAIL, org_id);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($759f37b5c33ecdfa$var$COM_CardPhones, {
        labels: labels,
        item: item,
        handleRecord: handleRecord,
        handleRecordDetail: handleRecordDetail,
        _link: link,
        _phone: phone_hotline,
        _bg: (0, (/*@__PURE__*/$parcel$interopDefault($4fe9aefd4efd98c4$exports)))
    });
};
const $759f37b5c33ecdfa$var$CardPublicPhone = ({ item: item, onClick: onClick, ...rest })=>{
    // NOTE: currently copied from hotline, use warmline background
    const { org_id: org_id, public_phone: public_phone } = item;
    const link = `tel:${(0, $cc5aa301cdd3eb9a$export$2e2bcd8739ae039).extractPhone(public_phone)}`;
    const handleRecord = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)(null)((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_PHONE, org_id, link);
    const handleRecordDetail = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)((item)=>{
        onClick(item);
    })((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_DETAIL, org_id);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($759f37b5c33ecdfa$var$COM_CardPhones, {
        ...rest,
        item: item,
        handleRecord: handleRecord,
        handleRecordDetail: handleRecordDetail,
        _link: link,
        _phone: public_phone,
        _bg: (0, (/*@__PURE__*/$parcel$interopDefault($4fe9aefd4efd98c4$exports)))
    });
};
const $759f37b5c33ecdfa$var$COM_CardPhones = ({ labels: labels, item: item, _link: _link, _phone: _phone, _bg: _bg, handleRecordDetail: handleRecordDetail, handleRecord: handleRecord })=>{
    const { org_id: org_id, name1: name1, name2: name2, phone_details: phone_details } = item;
    const title = [
        name1 || "",
        name2 || ""
    ].join(" ");
    const [fontSize, setFontSize] = (0, $8NFma.useState)("1em");
    const hiddenRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        const textWidth = hiddenRef.current.offsetWidth;
        // calculage the desired font size by textWidth and container width (CARD_WIDTH)
        const _fontSize = Math.min(2.5, $759f37b5c33ecdfa$var$TEXT_CONTAINER_WIDTH / textWidth) + "em";
        setFontSize(_fontSize);
    }, [
        _phone
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$aa3e815946b80764, $633e69fa81ff7bad$export$9eb297cdc7a32c58),
        style: {
            width: $759f37b5c33ecdfa$var$CARD_WIDTH
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$3cbbe2f4ae007ac0),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2dee8c321953b761$exports))),
                    alt: "phone",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$1ca1ec8b29a4ce27)
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                onClick: handleRecord,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$1c666b61ec7d376),
                href: _link,
                target: "_blank",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$29725192708d9349),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$a61973c5dd786949),
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$73920f18ca706874),
                                    ref: hiddenRef,
                                    children: _phone
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$321269ced4b4fd0a),
                                    style: {
                                        fontSize: fontSize
                                    },
                                    children: _phone
                                }),
                                phone_details ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    children: phone_details
                                }) : null,
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$d35f6a9f0135f711),
                                    children: labels["lbl_TapToCallNow"] || "Tap to call now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$6dd7c7168fc9f148),
                            style: {
                                background: `url(${_bg}) no-repeat center center`
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$4e6856be2fa35dca),
                onClick: ()=>{
                    handleRecordDetail(item);
                },
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$fb184b623420d9be),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($633e69fa81ff7bad$export$13a2d28b88853ef2),
                        children: labels["lbl_Details"] || "Details"
                    })
                ]
            })
        ]
    }, org_id);
};
var $759f37b5c33ecdfa$export$2e2bcd8739ae039 = $759f37b5c33ecdfa$var$Com;




var $8NFma = parcelRequire("8NFma");


var $08d5d49e2c8658e2$export$e8e78c978b129247;
var $08d5d49e2c8658e2$export$114dbff7fb2bf04f;
$08d5d49e2c8658e2$export$e8e78c978b129247 = `vtglDG_root`;
$08d5d49e2c8658e2$export$114dbff7fb2bf04f = `vtglDG_scaleUp`;
$08d5d49e2c8658e2$export$114dbff7fb2bf04f;


var $6f9b74c5ad62f06f$export$2e2bcd8739ae039 = ({ className: className, options: options, onClick: onClick, ...rest })=>{
    const {} = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const handleSelect = (o, idx)=>{
        // trigger parent onClick
        onClick(o, {});
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $08d5d49e2c8658e2$export$e8e78c978b129247),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("ul", {
            children: options && options.map((o, idx)=>{
                const { option: option } = o;
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        onClick: ()=>{
                            handleSelect(o, idx);
                        },
                        children: option
                    })
                }, `options_${idx}`);
            })
        })
    });
};


var $1b25b8b6117a493a$export$a3bc9b8ed74fc;
var $1b25b8b6117a493a$export$46c1c92549715335;
var $1b25b8b6117a493a$export$5be82eb8d376fece;
var $1b25b8b6117a493a$export$e8e78c978b129247;
var $1b25b8b6117a493a$export$114dbff7fb2bf04f;
$1b25b8b6117a493a$export$a3bc9b8ed74fc = `l0e3wW_error`;
$1b25b8b6117a493a$export$46c1c92549715335 = `l0e3wW_loading`;
$1b25b8b6117a493a$export$5be82eb8d376fece = `l0e3wW_results`;
$1b25b8b6117a493a$export$e8e78c978b129247 = `l0e3wW_root`;
$1b25b8b6117a493a$export$114dbff7fb2bf04f = `l0e3wW_scaleUp`;


const $53f6bb643f8b12d5$export$c25e0f8cca6c69a3 = ({ message: message = {}, step: step, idx: idx, type: type, ...props })=>{
    const { labels: labels } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const { data: data = [], errorMessage: errorMessage, isMessageLoading: isMessageLoading } = message;
    if (isMessageLoading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($1b25b8b6117a493a$export$e8e78c978b129247, $1b25b8b6117a493a$export$46c1c92549715335),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            children: labels["lbl_Loading"] || "Loading..."
        })
    });
    if (errorMessage) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($1b25b8b6117a493a$export$e8e78c978b129247, $1b25b8b6117a493a$export$a3bc9b8ed74fc),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("b", {
                    children: errorMessage
                }),
                ". ",
                labels["lbl_PleaseRetry"] || "Please retry",
                "."
            ]
        })
    });
    if (type === (0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.RESULTS) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($1b25b8b6117a493a$export$e8e78c978b129247, $1b25b8b6117a493a$export$5be82eb8d376fece),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $759f37b5c33ecdfa$export$2e2bcd8739ae039), {
            data: data
        })
    });
};
var $53f6bb643f8b12d5$export$2e2bcd8739ae039 = $53f6bb643f8b12d5$export$c25e0f8cca6c69a3;




var $8NFma = parcelRequire("8NFma");



parcelRequire("8NFma");
const $314b68a4e7c71a8b$var$MySVGComponent = (props)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("svg", {
        id: "icon_",
        "data-name": "icon / !",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 20 19",
        ...props,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("clipPath", {
                    id: "clip-path",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("ellipse", {
                        id: "Mask",
                        cx: "10",
                        cy: "9.5",
                        rx: "10",
                        ry: "9.5"
                    })
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("g", {
                id: "_",
                "data-name": "!",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("ellipse", {
                        id: "Mask-2",
                        "data-name": "Mask",
                        cx: "10",
                        cy: "9.5",
                        rx: "10",
                        ry: "9.5"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("g", {
                        id: "_2",
                        "data-name": "!",
                        clipPath: "url(#clip-path)",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                            id: "_3",
                            "data-name": "!",
                            d: "M0,10.71V8.4H2.355v2.31ZM.63,7.5.06,2.88V0H2.28V2.88L1.695,7.5Z",
                            transform: "translate(8.83 4.24)",
                            fill: "#ffead8"
                        })
                    })
                ]
            })
        ]
    });
var $314b68a4e7c71a8b$export$2e2bcd8739ae039 = $314b68a4e7c71a8b$var$MySVGComponent;


var $7fe3b7223de9cc6f$exports = {};

$parcel$export($7fe3b7223de9cc6f$exports, "error", () => $7fe3b7223de9cc6f$export$a3bc9b8ed74fc, (v) => $7fe3b7223de9cc6f$export$a3bc9b8ed74fc = v);
$parcel$export($7fe3b7223de9cc6f$exports, "icon", () => $7fe3b7223de9cc6f$export$1ca1ec8b29a4ce27, (v) => $7fe3b7223de9cc6f$export$1ca1ec8b29a4ce27 = v);
$parcel$export($7fe3b7223de9cc6f$exports, "message", () => $7fe3b7223de9cc6f$export$a8ecead220dd38a6, (v) => $7fe3b7223de9cc6f$export$a8ecead220dd38a6 = v);
$parcel$export($7fe3b7223de9cc6f$exports, "root", () => $7fe3b7223de9cc6f$export$e8e78c978b129247, (v) => $7fe3b7223de9cc6f$export$e8e78c978b129247 = v);
$parcel$export($7fe3b7223de9cc6f$exports, "scaleUp", () => $7fe3b7223de9cc6f$export$114dbff7fb2bf04f, (v) => $7fe3b7223de9cc6f$export$114dbff7fb2bf04f = v);
var $7fe3b7223de9cc6f$export$a3bc9b8ed74fc;
var $7fe3b7223de9cc6f$export$1ca1ec8b29a4ce27;
var $7fe3b7223de9cc6f$export$a8ecead220dd38a6;
var $7fe3b7223de9cc6f$export$e8e78c978b129247;
var $7fe3b7223de9cc6f$export$114dbff7fb2bf04f;
$7fe3b7223de9cc6f$export$a3bc9b8ed74fc = `V0b5gq_error`;
$7fe3b7223de9cc6f$export$1ca1ec8b29a4ce27 = `V0b5gq_icon`;
$7fe3b7223de9cc6f$export$a8ecead220dd38a6 = `V0b5gq_message`;
$7fe3b7223de9cc6f$export$e8e78c978b129247 = `V0b5gq_root`;
$7fe3b7223de9cc6f$export$114dbff7fb2bf04f = `V0b5gq_scaleUp`;


const $c5dd14c33ddf49cf$var$STAGE_DELAY = 3000;
const $c5dd14c33ddf49cf$export$c25e0f8cca6c69a3 = ({ message: message = {}, slId: slId, step: step, idx: idx, ...props })=>{
    const { onCancelSpeakLine: onCancelSpeakLine } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const { chatMessage: chatMessage, messageType: messageType = "error" } = message || {};
    const [isHovering, setIsHovering] = (0, $8NFma.useState)(false);
    const [remainingTime, setRemainingTime] = (0, $8NFma.useState)($c5dd14c33ddf49cf$var$STAGE_DELAY);
    const [startTime, setStartTime] = (0, $8NFma.useState)(Date.now());
    const timeRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        if (!isHovering) {
            timeRef.current = setTimeout(()=>{
                onCancelSpeakLine(slId);
            }, remainingTime);
            // Update start time when timer starts
            setStartTime(Date.now());
        }
        if (isHovering) {
            // Calculate remaining time if mouse is hovering and component unmounts or pauses
            setRemainingTime((oldTime)=>Math.max(0, oldTime - (Date.now() - startTime)));
            clearTimeout(timeRef.current);
        }
        return ()=>{
            /* 
      ISSUE HERE: 
        if multiple messages, will trigger all at once 
        because after cancel, the array shuffles, object renewed, so it rerenders component.
        before that, it will call "return"
      */ onCancelSpeakLine(slId);
            clearTimeout(timeRef.current);
        };
    }, [
        isHovering
    ]);
    const handleMouseEnter = ()=>{
        setIsHovering(true);
    };
    const handleMouseLeave = ()=>{
        setIsHovering(false);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($7fe3b7223de9cc6f$exports.root),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($7fe3b7223de9cc6f$exports.message, $7fe3b7223de9cc6f$exports?.[messageType] || ""),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($7fe3b7223de9cc6f$exports.icon),
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $314b68a4e7c71a8b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                    children: chatMessage
                })
            ]
        })
    });
};
var $c5dd14c33ddf49cf$export$2e2bcd8739ae039 = $c5dd14c33ddf49cf$export$c25e0f8cca6c69a3;


var $52f36b1f8604fe1a$export$a8ecead220dd38a6;
var $52f36b1f8604fe1a$export$114dbff7fb2bf04f;
$52f36b1f8604fe1a$export$a8ecead220dd38a6 = `_6i9NHG_message`;
$52f36b1f8604fe1a$export$114dbff7fb2bf04f = `_6i9NHG_scaleUp`;


var $435e93f5fd56869c$export$2e2bcd8739ae039 = ({ className: className, children: children, ...rest })=>{
    const { labels: labels, dialogueHistory: dialogueHistory } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
        children: [
            dialogueHistory?.map((item, idx)=>{
                const { character: character } = item;
                let jsxDisplay = null;
                const props = {
                    ...item,
                    idx: idx
                };
                switch(character){
                    case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.BOT:
                        jsxDisplay = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8bb40800d9add1cd$export$2e2bcd8739ae039), {
                            ...props
                        });
                        break;
                    case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.USER:
                        jsxDisplay = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $02fc6b22cf5a8d25$export$2e2bcd8739ae039), {
                            ...props
                        });
                        break;
                    case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.SYSTEM:
                        jsxDisplay = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $53f6bb643f8b12d5$export$2e2bcd8739ae039), {
                            ...props
                        });
                        break;
                    case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.STAGEMANAGER:
                        jsxDisplay = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c5dd14c33ddf49cf$export$2e2bcd8739ae039), {
                            ...props
                        });
                        break;
                    default:
                        break;
                }
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($52f36b1f8604fe1a$export$a8ecead220dd38a6),
                    children: jsxDisplay
                }, `message_${idx}`);
            }),
            children
        ]
    });
};




var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");



const $21faa4a5774077e0$var$CHARACTER = (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.USER;
/**
 * activaly triggered by user input (different than non-human characters)
 * @param {} props
 * @returns
 */ const $21faa4a5774077e0$var$useUser = (props)=>{
    const { onSpeakLine: onSpeakLine, tree: tree, setStage: setStage, onClaimPerformance: onClaimPerformance, onPerformance: onPerformance, onProcessPayload: onProcessPayload } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    /* 
    TODO: in the future, user is not an actor. actor is only AI/system characters
    user can send message as they want, and the system will process it
  */ const onProcessOption = (optionObj, input = {}, holding = false)=>{
        const performance = onClaimPerformance($21faa4a5774077e0$var$CHARACTER);
        if (!performance) return false;
        if (!holding) onPerformance();
        if (optionObj?.option) onSpeakLine($21faa4a5774077e0$var$CHARACTER, {
            chatMessage: optionObj.option
        });
        if (optionObj?.action) // if currentActor is cueActor, cue the next step
        setStage((prev)=>{
            const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(prev);
            (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "behavior.currentActor", $21faa4a5774077e0$var$CHARACTER);
            const currentPayload = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).get(_v, "userPayload", {});
            const _userPayload = onProcessPayload(optionObj, currentPayload);
            (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "userPayload", _userPayload);
            (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "currentStep", performance?.step);
            (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "nextStep", optionObj?.action);
            return _v;
        });
    /* 
      prevent director cue next character right away
      in case user has multiple messages and want to show them one bubble after another
      [20240729] currently we dont have this case. we always do "bot -> user" process
    */ };
    const onProcessInput = (input = {}, message, holding = false)=>{
        const performance = onClaimPerformance($21faa4a5774077e0$var$CHARACTER);
        if (!performance) return false;
        if (!holding) onPerformance();
        const { step: step } = performance;
        const { action: action } = tree[step] || {};
        if (input) {
            onSpeakLine($21faa4a5774077e0$var$CHARACTER, {
                chatMessage: message
            });
            setStage((prev)=>{
                const _v = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).cloneDeep(prev);
                (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "behavior.currentActor", $21faa4a5774077e0$var$CHARACTER);
                const currentPayload = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).get(_v, "userPayload", {});
                const payloadUpdator = {
                    values: input
                };
                const _userPayload = onProcessPayload(payloadUpdator, currentPayload);
                (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "userPayload", _userPayload);
                (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "currentStep", performance?.step);
                (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).set(_v, "nextStep", action);
                return _v;
            });
        }
    };
    return {
        onProcessOption: onProcessOption,
        onProcessInput: onProcessInput
    };
};
var $21faa4a5774077e0$export$2e2bcd8739ae039 = $21faa4a5774077e0$var$useUser;



var $66d64daa6847ddbd$export$db9f06b5d27d15d8;
var $66d64daa6847ddbd$export$e8e78c978b129247;
var $66d64daa6847ddbd$export$114dbff7fb2bf04f;
$66d64daa6847ddbd$export$db9f06b5d27d15d8 = `XFqhlG_question`;
$66d64daa6847ddbd$export$e8e78c978b129247 = `XFqhlG_root`;
$66d64daa6847ddbd$export$114dbff7fb2bf04f = `XFqhlG_scaleUp`;


var $922c47d3b7f3c3fc$export$2e2bcd8739ae039 = ({ className: className, ...rest })=>{
    const { tree: tree, labels: labels, stage: stage } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const { options: options } = tree[stage.currentStep] || {};
    const { onProcessOption: onProcessOption } = (0, $21faa4a5774077e0$export$2e2bcd8739ae039)();
    const handleApply = (...params)=>{
        onProcessOption(...params);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $66d64daa6847ddbd$export$e8e78c978b129247),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6f9b74c5ad62f06f$export$2e2bcd8739ae039), {
            options: options,
            onClick: handleApply
        })
    });
};




var $8NFma = parcelRequire("8NFma");






var $8NFma = parcelRequire("8NFma");



parcelRequire("8NFma");
const $661c397d2460c725$var$MySVGComponent = (props)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 500 500",
        ...props,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("g", {
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("polygon", {
                    points: "0,497.25 535.5,267.75 0,38.25 0,216.75 382.5,267.75 0,318.75"
                })
            })
        })
    });
var $661c397d2460c725$export$2e2bcd8739ae039 = $661c397d2460c725$var$MySVGComponent;


var $be52831e528f0aa6$export$19a5220a5de8494f;
var $be52831e528f0aa6$export$3566047a2d1b0764;
var $be52831e528f0aa6$export$e8e78c978b129247;
var $be52831e528f0aa6$export$114dbff7fb2bf04f;
$be52831e528f0aa6$export$19a5220a5de8494f = `Xg0vYq_inputApplyButton`;
$be52831e528f0aa6$export$3566047a2d1b0764 = `Xg0vYq_inputBoxContainer`;
$be52831e528f0aa6$export$e8e78c978b129247 = `Xg0vYq_root`;
$be52831e528f0aa6$export$114dbff7fb2bf04f = `Xg0vYq_scaleUp`;


var $f65d6ed5b33ff4d4$export$2e2bcd8739ae039 = ({ className: className, placeholder: placeholder, value: value, onChange: onChange, onApply: onApply, ...rest })=>{
    const {} = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") onApply(e);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $be52831e528f0aa6$export$e8e78c978b129247),
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($be52831e528f0aa6$export$3566047a2d1b0764),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                    type: "text",
                    onKeyDown: handleKeyDown,
                    placeholder: placeholder,
                    onChange: onChange,
                    value: value
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($be52831e528f0aa6$export$19a5220a5de8494f),
                onClick: onApply,
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $661c397d2460c725$export$2e2bcd8739ae039), {})
            })
        ]
    });
};


var $58a68e3b71f3d7ce$export$e8e78c978b129247;
var $58a68e3b71f3d7ce$export$114dbff7fb2bf04f;
$58a68e3b71f3d7ce$export$e8e78c978b129247 = `UNV0Ua_root`;
$58a68e3b71f3d7ce$export$114dbff7fb2bf04f = `UNV0Ua_scaleUp`;


var $c131524ff50fa967$export$2e2bcd8739ae039 = ({ className: className, ...rest })=>{
    const { tree: tree, labels: labels, stage: stage, onError: onError, country: country = "US" } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const [value, setValue] = (0, $8NFma.useState)("");
    // const { options } = tree[stage?.currentStep] || {}
    const { onProcessInput: onProcessInput } = (0, $21faa4a5774077e0$export$2e2bcd8739ae039)();
    const handleChange = (e)=>{
        setValue(e.target.value);
    };
    const handleApply = ()=>{
        if (!value) {
            onError(labels["lbl_Invalid_ZipCode"]);
            return;
        }
        // validate zip
        const regexZip = (0, $cc5aa301cdd3eb9a$export$2e2bcd8739ae039).regexForZips[country].regex;
        const regexResult = new RegExp(regexZip);
        if (!regexResult.test(value)) {
            onError(labels["lbl_Invalid_ZipCode"] || (0, $cc5aa301cdd3eb9a$export$2e2bcd8739ae039).regexForZips[country].message);
            return;
        }
        onProcessInput({
            zip: value
        }, value);
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $58a68e3b71f3d7ce$export$e8e78c978b129247),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f65d6ed5b33ff4d4$export$2e2bcd8739ae039), {
            onChange: handleChange,
            onApply: handleApply,
            value: value
        })
    });
};


var $851521fe602d1d94$exports = {};

$parcel$export($851521fe602d1d94$exports, "dot", () => $851521fe602d1d94$export$94132a0e348806d4, (v) => $851521fe602d1d94$export$94132a0e348806d4 = v);
$parcel$export($851521fe602d1d94$exports, "dot-flash", () => $851521fe602d1d94$export$bbeb05a16995e6da, (v) => $851521fe602d1d94$export$bbeb05a16995e6da = v);
$parcel$export($851521fe602d1d94$exports, "hide", () => $851521fe602d1d94$export$fe8985bb6374093c, (v) => $851521fe602d1d94$export$fe8985bb6374093c = v);
$parcel$export($851521fe602d1d94$exports, "loading_dots", () => $851521fe602d1d94$export$5dc9041603a055cb, (v) => $851521fe602d1d94$export$5dc9041603a055cb = v);
$parcel$export($851521fe602d1d94$exports, "loading_dots_container", () => $851521fe602d1d94$export$75c94a9e302200ba, (v) => $851521fe602d1d94$export$75c94a9e302200ba = v);
$parcel$export($851521fe602d1d94$exports, "root", () => $851521fe602d1d94$export$e8e78c978b129247, (v) => $851521fe602d1d94$export$e8e78c978b129247 = v);
$parcel$export($851521fe602d1d94$exports, "scaleUp", () => $851521fe602d1d94$export$114dbff7fb2bf04f, (v) => $851521fe602d1d94$export$114dbff7fb2bf04f = v);
$parcel$export($851521fe602d1d94$exports, "show", () => $851521fe602d1d94$export$57bf213be019eeb0, (v) => $851521fe602d1d94$export$57bf213be019eeb0 = v);
var $851521fe602d1d94$export$94132a0e348806d4;
var $851521fe602d1d94$export$bbeb05a16995e6da;
var $851521fe602d1d94$export$fe8985bb6374093c;
var $851521fe602d1d94$export$5dc9041603a055cb;
var $851521fe602d1d94$export$75c94a9e302200ba;
var $851521fe602d1d94$export$e8e78c978b129247;
var $851521fe602d1d94$export$114dbff7fb2bf04f;
var $851521fe602d1d94$export$57bf213be019eeb0;
$851521fe602d1d94$export$94132a0e348806d4 = `lwT3wq_dot`;
$851521fe602d1d94$export$bbeb05a16995e6da = `lwT3wq_dot-flash`;
$851521fe602d1d94$export$bbeb05a16995e6da;
$851521fe602d1d94$export$fe8985bb6374093c = `lwT3wq_hide`;
$851521fe602d1d94$export$5dc9041603a055cb = `lwT3wq_loading_dots`;
$851521fe602d1d94$export$75c94a9e302200ba = `lwT3wq_loading_dots_container`;
$851521fe602d1d94$export$e8e78c978b129247 = `lwT3wq_root`;
$851521fe602d1d94$export$114dbff7fb2bf04f = `lwT3wq_scaleUp`;
$851521fe602d1d94$export$57bf213be019eeb0 = `lwT3wq_show`;



const $24c77da71b238c07$var$Components = {
    [(0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.LOC_ZIP]: (0, $c131524ff50fa967$export$2e2bcd8739ae039),
    [(0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.OPTIONS]: (0, $922c47d3b7f3c3fc$export$2e2bcd8739ae039),
    [(0, $b2e6864aad7029da$export$2e2bcd8739ae039).stepTypes.OPTIONS_ONLY]: (0, $922c47d3b7f3c3fc$export$2e2bcd8739ae039)
};
var $24c77da71b238c07$export$2e2bcd8739ae039 = ({ className: className, ...rest })=>{
    const { tree: tree, stage: stage, waitingQueue: waitingQueue, show: show } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const currentType = tree[stage?.currentStep]?.type;
    // load different inputs
    const Com = $24c77da71b238c07$var$Components[currentType] || (0, $922c47d3b7f3c3fc$export$2e2bcd8739ae039);
    const currentActor = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).get(stage, "behavior.currentActor", "");
    const isInputDisplay = waitingQueue?.[0]?.character === (0, $b2e6864aad7029da$export$2e2bcd8739ae039).characters.USER;
    if (!isInputDisplay) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $851521fe602d1d94$exports.loading_dots_container, $851521fe602d1d94$exports.root),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($851521fe602d1d94$exports.loading_dots),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($851521fe602d1d94$exports.dot)
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($851521fe602d1d94$exports.dot)
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($851521fe602d1d94$exports.dot)
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $851521fe602d1d94$exports.root, $851521fe602d1d94$exports[show ? "show" : "hide"]),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Com, {})
    });
};


var $0abc516339384425$export$28854150e7f765bb;
var $0abc516339384425$export$9fba871cbb0ec18b;
var $0abc516339384425$export$defe85febe8b728c;
var $0abc516339384425$export$e8e78c978b129247;
var $0abc516339384425$export$114dbff7fb2bf04f;
$0abc516339384425$export$28854150e7f765bb = `iHTztq_chatbox`;
$0abc516339384425$export$9fba871cbb0ec18b = `iHTztq_inputzone`;
$0abc516339384425$export$defe85febe8b728c = `iHTztq_messages`;
$0abc516339384425$export$e8e78c978b129247 = `iHTztq_root`;
$0abc516339384425$export$114dbff7fb2bf04f = `iHTztq_scaleUp`;


var $12f3b17fab02290c$export$2e2bcd8739ae039 = ({ className: className, ...rest })=>{
    const { tree: tree } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const containerRef = (0, $8NFma.useRef)(null);
    const inputRef = (0, $8NFma.useRef)(null);
    const modalRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        if (modalRef.current) {
            const modalElement = modalRef.current.querySelector(".message_scroll");
            const inputElement = inputRef.current;
            const handleScroll = (event)=>{
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = modalElement;
                // prevent scroll up, but allow scroll down
                if (scrollTop === 0 && event.deltaY < 0) event.preventDefault();
                // prevent scroll down, but allow scroll up
                if (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0) event.preventDefault();
            };
            const handleTouchMove = (event)=>{
                if (!event.cancelable) return;
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = modalElement;
                const touch = event.touches[0];
                // prevent scroll up, but allow scroll down
                if (scrollTop === 0 && touch.clientY > touchStartY) event.preventDefault();
                // prevent scroll down, but allow scroll up
                if (scrollTop + clientHeight >= scrollHeight && touch.clientY < touchStartY) event.preventDefault();
            };
            const handleTouchStart = (event)=>{
                touchStartY = event.touches[0].clientY;
            };
            let touchStartY = 0;
            modalElement.addEventListener("wheel", handleScroll);
            modalElement.addEventListener("touchstart", handleTouchStart);
            modalElement.addEventListener("touchmove", handleTouchMove);
            // handle browser deprecated event causes scroll issue
            const observer = $12f3b17fab02290c$var$patchOnScrollIssue(modalElement);
            const observerInput = $12f3b17fab02290c$var$patchOnScrollIssue(modalElement, inputElement);
            return ()=>{
                modalElement.removeEventListener("wheel", handleScroll);
                modalElement.removeEventListener("touchstart", handleTouchStart);
                modalElement.removeEventListener("touchmove", handleTouchMove);
                // handle browser deprecated event causes scroll issue
                if (observer) observer.disconnect();
                if (observerInput) observerInput.disconnect();
            };
        }
    }, [
        modalRef.current
    ]);
    if (!tree) return null;
    // print current scroll height
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        ref: modalRef,
        style: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $0abc516339384425$export$e8e78c978b129247),
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($0abc516339384425$export$28854150e7f765bb),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("message_scroll", $0abc516339384425$export$defe85febe8b728c),
                    ref: containerRef,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $435e93f5fd56869c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($0abc516339384425$export$9fba871cbb0ec18b),
                            ref: inputRef,
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $24c77da71b238c07$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        })
    });
};
const $12f3b17fab02290c$var$patchOnScrollIssue = (modalElement, monitorElement)=>{
    // Callback function to handle mutations
    const mutationCallback = (mutationsList)=>{
        for (let mutation of mutationsList)if (mutation.type === "childList" && mutation.addedNodes.length > 0) // modalElement.scrollTo({
        //   top: modalElement.scrollHeight,
        //   behavior: 'smooth'
        // });
        $12f3b17fab02290c$var$smoothScroll(modalElement, modalElement.scrollHeight, 500);
    };
    // Create a MutationObserver instance and pass the callback function
    const observer = new MutationObserver(mutationCallback);
    if (monitorElement || modalElement) observer.observe(monitorElement || modalElement, {
        childList: true,
        subtree: true,
        characterData: true
    });
    // Cleanup function to disconnect the observer when the component unmounts
    return observer;
};
function $12f3b17fab02290c$var$smoothScroll(element, target, duration) {
    const start = element.scrollTop;
    const distance = target - start;
    let startTime = null;
    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, start, distance, duration);
        element.scrollTop = run;
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }
    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }
    requestAnimationFrame(animation);
}




var $8NFma = parcelRequire("8NFma");

var $O6tRJ = parcelRequire("O6tRJ");


var $2796d8afafa8991d$exports = {};

$2796d8afafa8991d$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "phone-solid.1c6138d0.svg";


var $779375ad521c1cc6$exports = {};

$779375ad521c1cc6$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "message-bubble.7692c3c9.svg";


var $fd092137f4f94991$exports = {};

$fd092137f4f94991$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "mobile-checkins.c2a4123d.svg";


var $70db6d328b708217$exports = {};

$70db6d328b708217$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "circle-check.44ba47e6.svg";








var $c36e373c395268ae$export$f7d3c097ceca6c15;
var $c36e373c395268ae$export$32180ef41b15b513;
var $c36e373c395268ae$export$38e42c68cf43b5d4;
var $c36e373c395268ae$export$1ca1ec8b29a4ce27;
var $c36e373c395268ae$export$29725192708d9349;
var $c36e373c395268ae$export$ff7962acd6052c28;
var $c36e373c395268ae$export$aaae5db3a8d5c20b;
var $c36e373c395268ae$export$58ee0ea85d7a10b9;
var $c36e373c395268ae$export$27364736a9ec4830;
var $c36e373c395268ae$export$114dbff7fb2bf04f;
var $c36e373c395268ae$export$bce7a36871692cab;
var $c36e373c395268ae$export$fb184b623420d9be;
var $c36e373c395268ae$export$12948adc4d562794;
var $c36e373c395268ae$export$61f6990d5944375a;
$c36e373c395268ae$export$f7d3c097ceca6c15 = `xUVbMa_address`;
$c36e373c395268ae$export$32180ef41b15b513 = `xUVbMa_body`;
$c36e373c395268ae$export$38e42c68cf43b5d4 = `xUVbMa_header`;
$c36e373c395268ae$export$1ca1ec8b29a4ce27 = `xUVbMa_icon`;
$c36e373c395268ae$export$29725192708d9349 = `xUVbMa_logo_container`;
$c36e373c395268ae$export$ff7962acd6052c28 = `xUVbMa_navigate`;
$c36e373c395268ae$export$aaae5db3a8d5c20b = `xUVbMa_payments`;
$c36e373c395268ae$export$58ee0ea85d7a10b9 = `xUVbMa_phone`;
$c36e373c395268ae$export$27364736a9ec4830 = `xUVbMa_phone_miles`;
$c36e373c395268ae$export$114dbff7fb2bf04f = `xUVbMa_scaleUp`;
$c36e373c395268ae$export$bce7a36871692cab = `xUVbMa_services`;
$c36e373c395268ae$export$fb184b623420d9be = `xUVbMa_title`;
$c36e373c395268ae$export$12948adc4d562794 = `xUVbMa_titleContainer`;
$c36e373c395268ae$export$61f6990d5944375a = `xUVbMa_website`;


// categories that are reserved for special services won't be displayed
const $1e6c408e953f9e20$var$RESERVED_SERVICE_CATEGORIES = {
    HT: true,
    CTRL: true
};
var $1e6c408e953f9e20$export$2e2bcd8739ae039 = ({ className: className, ...rest })=>{
    const { zIndex: zIndex, showFacility: showFacility, token: token, labels: labels, isPreview: isPreview } = (0, $8NFma.useContext)((0, $f8afb0169f3a1369$export$ae9a8eaefa5810ed));
    const { getImage: getImage } = (0, $85a1be93bd0bcb9d$export$2e2bcd8739ae039)();
    const [moreInfo, setMoreInfo] = (0, $8NFma.useState)(null);
    const [services, setServices] = (0, $8NFma.useState)(null);
    const isShow = showFacility?.org_id;
    (0, $8NFma.useEffect)(()=>{
        if (showFacility?.org_id) doGetFacility(showFacility.org_id);
        else setMoreInfo(null);
    }, [
        isShow
    ]);
    // if (!isShow) return null
    const doGetFacility = async (org_id)=>{
        const res = await (0, $726aa11b12c82653$export$2e2bcd8739ae039).getFacility(token, org_id, {
            isPreview: isPreview
        }) || null;
        // split AllSCodes by category_code, display scode_name (in the future, scode_label)
        if (res?.AllSCodes) {
            const _services = {};
            res.AllSCodes.forEach((scode)=>{
                const { category_code: category_code, scode_name: scode_name, category_name: category_name } = scode;
                if ($1e6c408e953f9e20$var$RESERVED_SERVICE_CATEGORIES[category_code]) return;
                if (!category_code) {
                    console.log("category_code is missing in scode", scode);
                    return;
                }
                if (!_services[category_code]) _services[category_code] = {
                    category_name: category_name,
                    scodes: []
                };
                _services[category_code].scodes.push({
                    scode_name: scode_name
                });
            });
            setServices(_services);
        }
        setMoreInfo({
            ...showFacility,
            ...res
        });
        return;
    };
    const { org_id: org_id, logo: logo, description: description, name1: name1, name2: name2, street1: street1, street2: street2, region: region, city: city, zip: zip, latitude: latitude, longitude: longitude, country: country = "US", public_phone: public_phone, phone_hotline: phone_hotline, phone_hotline2: phone_hotline2, phone_details: phone_details, phone_intake1: phone_intake1, phone_intake2: phone_intake2, sms: sms, sms_msg: sms_msg, sms_details: sms_details, website: website, distance: distance } = moreInfo || {};
    const handleRecord = (0, $1f43aaaca7086c0e$export$2e2bcd8739ae039)(null);
    const hrefWebsite = website;
    const hrefPublicPhone = `tel:${$1e6c408e953f9e20$var$formatPhoneNumber(public_phone)}`;
    const hrefPhoneHotline = `tel:${$1e6c408e953f9e20$var$formatPhoneNumber(phone_hotline)}`;
    const hrefSms = `sms:${$1e6c408e953f9e20$var$formatPhoneNumber(sms)}?body=${sms_msg}`;
    const full_address = [
        street1,
        street2,
        city,
        region,
        zip
    ]?.filter((a)=>a).join(", ");
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className),
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$38e42c68cf43b5d4),
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$29725192708d9349),
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                src: getImage(logo) || (0, (/*@__PURE__*/$parcel$interopDefault($581a518146acd46a$exports))),
                                alt: "logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$12948adc4d562794),
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$fb184b623420d9be),
                                children: [
                                    name1,
                                    name2
                                ].join("\n")
                            }),
                            website ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                onClick: handleRecord((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_WEBSITE, org_id, hrefWebsite),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$61f6990d5944375a),
                                href: hrefWebsite,
                                target: "_blank",
                                rel: "noreferrer",
                                children: labels["lbl_VisitWebsite"] || "Visit Website"
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$32180ef41b15b513),
                children: [
                    public_phone ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$58ee0ea85d7a10b9),
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                            onClick: handleRecord((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_PUBLICPHONE, org_id, hrefPublicPhone),
                            href: hrefPublicPhone,
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$1ca1ec8b29a4ce27),
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2796d8afafa8991d$exports))),
                                    alt: "phone"
                                }),
                                public_phone
                            ]
                        })
                    }) : null,
                    phone_hotline ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$58ee0ea85d7a10b9),
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                onClick: handleRecord((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_HOTLINE, org_id, hrefPhoneHotline),
                                href: hrefPhoneHotline,
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$1ca1ec8b29a4ce27),
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2796d8afafa8991d$exports))),
                                        alt: "hotline"
                                    }),
                                    phone_hotline
                                ]
                            }),
                            phone_details ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                children: phone_details
                            }) : null
                        ]
                    }) : null,
                    phone_hotline2 ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$58ee0ea85d7a10b9),
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$1ca1ec8b29a4ce27),
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2796d8afafa8991d$exports))),
                                    alt: "hotline"
                                }),
                                phone_hotline2
                            ]
                        })
                    }) : null,
                    sms ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$58ee0ea85d7a10b9),
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                onClick: handleRecord((0, $b2e6864aad7029da$export$2e2bcd8739ae039).ACTIVITY_TYPES.FAC_EXT_SMS, org_id, hrefSms),
                                href: hrefSms,
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$1ca1ec8b29a4ce27),
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($779375ad521c1cc6$exports))),
                                        alt: "sms"
                                    }),
                                    sms
                                ]
                            }),
                            sms_details ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                children: sms_details
                            }) : null
                        ]
                    }) : null,
                    full_address ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$27364736a9ec4830),
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$f7d3c097ceca6c15),
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$1ca1ec8b29a4ce27),
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd092137f4f94991$exports))),
                                    alt: labels["lbl_map"] || "map"
                                }),
                                full_address,
                                " ",
                                distance ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                    children: [
                                        "(",
                                        (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).round(distance, 1) || "--",
                                        " miles)"
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$ff7962acd6052c28),
                                    href: `https://www.google.com/maps/search/?api=1&query=${$1e6c408e953f9e20$var$formatAddressForGoogleMaps([
                                        street1,
                                        city,
                                        region,
                                        zip
                                    ].join(", "))}`,
                                    target: "_blank",
                                    children: labels["lbl_map"] || "map"
                                }),
                                " "
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                    (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).keys(services)?.map((category_code, index)=>{
                        const { category_name: category_name, scodes: scodes } = services[category_code];
                        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$bce7a36871692cab),
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($c36e373c395268ae$export$fb184b623420d9be),
                                    children: category_name
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("ul", {
                                    children: scodes?.map((scode, index)=>{
                                        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($70db6d328b708217$exports)))
                                                }),
                                                scode.scode_name
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        }, index);
                    })
                ]
            })
        ]
    });
};
function $1e6c408e953f9e20$var$formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "#";
    // Remove any non-numeric characters (except the plus sign)
    let formattedNumber = phoneNumber.replace(/[^\d+]/g, "");
    return formattedNumber;
}
function $1e6c408e953f9e20$var$formatAddressForGoogleMaps(address) {
    // Replace spaces with plus signs and encode special characters
    return encodeURIComponent(address.trim().replace(/\s+/g, "+"));
}




var $8NFma = parcelRequire("8NFma");
parcelRequire("O6tRJ");


parcelRequire("8NFma");
const $b731f4a767143fa3$var$MySVGComponent = ({})=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36.573 36.573",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("g", {
            id: "ios-checkmark-circle-outline",
            transform: "translate(0.5 0.5)",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                    id: "Path_72",
                    "data-name": "Path 72",
                    d: "M166.546,175.267l-1.491-1.563a.318.318,0,0,0-.237-.1.3.3,0,0,0-.237.1l-10.335,10.614-3.761-3.835a.323.323,0,0,0-.474,0l-1.508,1.537a.349.349,0,0,0,0,.492l4.744,4.837a1.489,1.489,0,0,0,.991.492,1.561,1.561,0,0,0,.983-.475h.008l11.326-11.608A.375.375,0,0,0,166.546,175.267Z",
                    transform: "translate(-139.729 -162.93)"
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                    id: "Path_73",
                    "data-name": "Path 73",
                    d: "M65.786,50.394A15.386,15.386,0,1,1,54.9,54.9a15.29,15.29,0,0,1,10.886-4.506m0-2.394A17.786,17.786,0,1,0,83.573,65.786,17.784,17.784,0,0,0,65.786,48Z",
                    transform: "translate(-48 -48)"
                })
            ]
        })
    });
var $b731f4a767143fa3$export$2e2bcd8739ae039 = $b731f4a767143fa3$var$MySVGComponent;



parcelRequire("8NFma");
const $adda1c9d6f4854bf$var$MySVGComponent = (props)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "language",
        className: "svg-inline--fa fa-language fa-w-20",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 640 512",
        ...props,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
            d: "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
        })
    });
var $adda1c9d6f4854bf$export$2e2bcd8739ae039 = $adda1c9d6f4854bf$var$MySVGComponent;






var $97f8c97a25859df8$export$89da14300d534261;
var $97f8c97a25859df8$export$32180ef41b15b513;
var $97f8c97a25859df8$export$42405f212471e8a2;
var $97f8c97a25859df8$export$38e42c68cf43b5d4;
var $97f8c97a25859df8$export$9e9706b9843a7198;
var $97f8c97a25859df8$export$7061c75fc5af8b7e;
var $97f8c97a25859df8$export$cfa784b45fc7b21d;
var $97f8c97a25859df8$export$de80dc1d40357cbf;
var $97f8c97a25859df8$export$bd0d4a71e7ca2245;
var $97f8c97a25859df8$export$1b9b24bdbcc25a11;
var $97f8c97a25859df8$export$e8e78c978b129247;
var $97f8c97a25859df8$export$114dbff7fb2bf04f;
var $97f8c97a25859df8$export$352c9af4294d9c2e;
var $97f8c97a25859df8$export$6a4f76733e9d28eb;
$97f8c97a25859df8$export$89da14300d534261 = `k9B-tq_active`;
$97f8c97a25859df8$export$32180ef41b15b513 = `k9B-tq_body`;
$97f8c97a25859df8$export$42405f212471e8a2 = `k9B-tq_flag`;
$97f8c97a25859df8$export$38e42c68cf43b5d4 = `k9B-tq_header`;
$97f8c97a25859df8$export$9e9706b9843a7198 = `k9B-tq_headerButton`;
$97f8c97a25859df8$export$7061c75fc5af8b7e = `k9B-tq_item`;
$97f8c97a25859df8$export$cfa784b45fc7b21d = `k9B-tq_itemIcon`;
$97f8c97a25859df8$export$de80dc1d40357cbf = `k9B-tq_itemText`;
$97f8c97a25859df8$export$bd0d4a71e7ca2245 = `k9B-tq_languageIcon`;
$97f8c97a25859df8$export$1b9b24bdbcc25a11 = `k9B-tq_listContainer`;
$97f8c97a25859df8$export$e8e78c978b129247 = `k9B-tq_root`;
$97f8c97a25859df8$export$114dbff7fb2bf04f = `k9B-tq_scaleUp`;
$97f8c97a25859df8$export$352c9af4294d9c2e = `k9B-tq_tabActive`;
$97f8c97a25859df8$export$6a4f76733e9d28eb = `k9B-tq_tabInactive`;


var $2c618c97a8c42165$export$2e2bcd8739ae039 = ({ className: className, ...rest })=>{
    const [tab, setTab] = (0, $8NFma.useState)("language");
    const { languageList: languageList, language: language, countryList: countryList, country: country } = (0, $8NFma.useContext)((0, $f8afb0169f3a1369$export$ae9a8eaefa5810ed));
    const languageObj = languageList.find((item)=>item.language_code === language);
    const countryObj = countryList.find((item)=>item.country_code === country);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$e8e78c978b129247, className),
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$38e42c68cf43b5d4),
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("button", {
                        onClick: ()=>setTab("language"),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$9e9706b9843a7198, tab === "language" && $97f8c97a25859df8$export$89da14300d534261),
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $adda1c9d6f4854bf$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$bd0d4a71e7ca2245)
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                children: languageObj?.native_name || "Language"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("button", {
                        onClick: ()=>setTab("country"),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$9e9706b9843a7198, tab === "country" && $97f8c97a25859df8$export$89da14300d534261),
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$42405f212471e8a2),
                                src: `${(0, $726aa11b12c82653$export$2e2bcd8739ae039).CND_SERVER}/images/countries/${country?.toLowerCase()}.svg`
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                children: countryObj?.country_name || "Country"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2c618c97a8c42165$var$ListLanguages, {
                tab: tab
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($2c618c97a8c42165$var$ListCountries, {
                tab: tab
            })
        ]
    });
};
const $2c618c97a8c42165$var$ListLanguages = ({ tab: tab })=>{
    const { onSwitchLanguage: onSwitchLanguage, languageList: languageList, language: language } = (0, $8NFma.useContext)((0, $f8afb0169f3a1369$export$ae9a8eaefa5810ed));
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$32180ef41b15b513, tab === "language" ? $97f8c97a25859df8$export$352c9af4294d9c2e : $97f8c97a25859df8$export$6a4f76733e9d28eb),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$1b9b24bdbcc25a11),
            children: languageList.map((item, index)=>{
                const { language_code: language_code, native_name: native_name } = item;
                const isActive = language === language_code;
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$7061c75fc5af8b7e, isActive && $97f8c97a25859df8$export$89da14300d534261),
                    onClick: ()=>onSwitchLanguage(language_code),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$de80dc1d40357cbf),
                            children: native_name
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$cfa784b45fc7b21d),
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b731f4a767143fa3$export$2e2bcd8739ae039), {})
                        })
                    ]
                }, index);
            })
        })
    });
};
const $2c618c97a8c42165$var$ListCountries = ({ tab: tab })=>{
    const { onSwitchCountry: onSwitchCountry, countryList: countryList, country: country } = (0, $8NFma.useContext)((0, $f8afb0169f3a1369$export$ae9a8eaefa5810ed));
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$32180ef41b15b513, tab === "country" ? $97f8c97a25859df8$export$352c9af4294d9c2e : $97f8c97a25859df8$export$6a4f76733e9d28eb),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$1b9b24bdbcc25a11),
            children: countryList.map((item, index)=>{
                const { country_code: country_code, country_name: country_name } = item;
                const isActive = country === country_code;
                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$7061c75fc5af8b7e, isActive && $97f8c97a25859df8$export$89da14300d534261),
                    onClick: ()=>onSwitchCountry(country_code),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$de80dc1d40357cbf),
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$42405f212471e8a2),
                                    src: `${(0, $726aa11b12c82653$export$2e2bcd8739ae039).CND_SERVER}/images/countries/${country_code?.toLowerCase()}.svg`
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    children: country_name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($97f8c97a25859df8$export$cfa784b45fc7b21d),
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b731f4a767143fa3$export$2e2bcd8739ae039), {})
                        })
                    ]
                }, index);
            })
        })
    });
};




var $8NFma = parcelRequire("8NFma");
parcelRequire("O6tRJ");


var $6310d8dff01d7e5f$export$72a2cd73ec8d3e3d;
var $6310d8dff01d7e5f$export$fe8985bb6374093c;
var $6310d8dff01d7e5f$export$e8e78c978b129247;
var $6310d8dff01d7e5f$export$114dbff7fb2bf04f;
var $6310d8dff01d7e5f$export$57bf213be019eeb0;
$6310d8dff01d7e5f$export$72a2cd73ec8d3e3d = `_7DEjqq_ModalScrollContainer`;
$6310d8dff01d7e5f$export$fe8985bb6374093c = `_7DEjqq_hide`;
$6310d8dff01d7e5f$export$e8e78c978b129247 = `_7DEjqq_root`;
$6310d8dff01d7e5f$export$114dbff7fb2bf04f = `_7DEjqq_scaleUp`;
$6310d8dff01d7e5f$export$57bf213be019eeb0 = `_7DEjqq_show`;


var $70c6311ae6029a37$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef(({ isShow: isShow, children: children, className: className, ...rest }, ref)=>{
    const { uiDrawer: uiDrawer, zIndex: zIndex } = (0, $8NFma.useContext)((0, $f8afb0169f3a1369$export$ae9a8eaefa5810ed));
    const modalRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        if (modalRef.current) {
            const modalElement = modalRef.current;
            const handleScroll = (event)=>{
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = modalElement;
                // prevent scroll up, but allow scroll down
                if (scrollTop === 0 && event.deltaY < 0) event.preventDefault();
                // prevent scroll down, but allow scroll up
                if (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0) event.preventDefault();
            };
            const handleTouchMove = (event)=>{
                if (!event.cancelable) return;
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = modalElement;
                const touch = event.touches[0];
                // prevent scroll up, but allow scroll down
                if (scrollTop === 0 && touch.clientY > touchStartY) event.preventDefault();
                // prevent scroll down, but allow scroll up
                if (scrollTop + clientHeight >= scrollHeight && touch.clientY < touchStartY) event.preventDefault();
            };
            const handleTouchStart = (event)=>{
                touchStartY = event.touches[0].clientY;
            };
            let touchStartY = 0;
            // get the modal element
            modalElement.addEventListener("wheel", handleScroll);
            modalElement.addEventListener("touchstart", handleTouchStart);
            modalElement.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                modalElement.removeEventListener("wheel", handleScroll);
                modalElement.removeEventListener("touchstart", handleTouchStart);
                modalElement.removeEventListener("touchmove", handleTouchMove);
            };
        }
    }, [
        modalRef.current
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(className, $6310d8dff01d7e5f$export$e8e78c978b129247, uiDrawer ? $6310d8dff01d7e5f$export$57bf213be019eeb0 : $6310d8dff01d7e5f$export$fe8985bb6374093c),
        ...rest,
        style: {
            zIndex: zIndex + 1
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($6310d8dff01d7e5f$export$72a2cd73ec8d3e3d),
            ref: modalRef,
            children: children
        })
    });
});



var $96387b9397562cc9$exports = {};

$96387b9397562cc9$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "close.bc7dfc3c.svg";


var $98ed19bbe44618bd$exports = {};

$98ed19bbe44618bd$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "minus.f7625ea0.svg";



var $53e85f846a28c66e$exports = {};

$53e85f846a28c66e$exports = (parcelRequire("lIGhs")).getBundleURL("hstjT") + "angle-left-solid.3468c917.svg";



var $707798b68636ebe6$exports = {};

$parcel$export($707798b68636ebe6$exports, "LTR", () => $707798b68636ebe6$export$373e92e0788ff06e, (v) => $707798b68636ebe6$export$373e92e0788ff06e = v);
$parcel$export($707798b68636ebe6$exports, "RTL", () => $707798b68636ebe6$export$850f7749a2909601, (v) => $707798b68636ebe6$export$850f7749a2909601 = v);
$parcel$export($707798b68636ebe6$exports, "assistant_name", () => $707798b68636ebe6$export$315b15ee15c687e7, (v) => $707798b68636ebe6$export$315b15ee15c687e7 = v);
$parcel$export($707798b68636ebe6$exports, "backText", () => $707798b68636ebe6$export$c159eaa54b4d0936, (v) => $707798b68636ebe6$export$c159eaa54b4d0936 = v);
$parcel$export($707798b68636ebe6$exports, "chatbox", () => $707798b68636ebe6$export$28854150e7f765bb, (v) => $707798b68636ebe6$export$28854150e7f765bb = v);
$parcel$export($707798b68636ebe6$exports, "chatboxContainer", () => $707798b68636ebe6$export$13fb59bcce76d3bb, (v) => $707798b68636ebe6$export$13fb59bcce76d3bb = v);
$parcel$export($707798b68636ebe6$exports, "error", () => $707798b68636ebe6$export$a3bc9b8ed74fc, (v) => $707798b68636ebe6$export$a3bc9b8ed74fc = v);
$parcel$export($707798b68636ebe6$exports, "float", () => $707798b68636ebe6$export$6b5cd3983e3ee5ab, (v) => $707798b68636ebe6$export$6b5cd3983e3ee5ab = v);
$parcel$export($707798b68636ebe6$exports, "floatAvatar", () => $707798b68636ebe6$export$87d2c27aff778f15, (v) => $707798b68636ebe6$export$87d2c27aff778f15 = v);
$parcel$export($707798b68636ebe6$exports, "floatContainer", () => $707798b68636ebe6$export$bb4b59f84891dd48, (v) => $707798b68636ebe6$export$bb4b59f84891dd48 = v);
$parcel$export($707798b68636ebe6$exports, "header", () => $707798b68636ebe6$export$38e42c68cf43b5d4, (v) => $707798b68636ebe6$export$38e42c68cf43b5d4 = v);
$parcel$export($707798b68636ebe6$exports, "headerContainer", () => $707798b68636ebe6$export$e052384d4071fee2, (v) => $707798b68636ebe6$export$e052384d4071fee2 = v);
$parcel$export($707798b68636ebe6$exports, "hide", () => $707798b68636ebe6$export$fe8985bb6374093c, (v) => $707798b68636ebe6$export$fe8985bb6374093c = v);
$parcel$export($707798b68636ebe6$exports, "iconBack", () => $707798b68636ebe6$export$fbfa78172a2accb2, (v) => $707798b68636ebe6$export$fbfa78172a2accb2 = v);
$parcel$export($707798b68636ebe6$exports, "iconCloseContainer", () => $707798b68636ebe6$export$cc87a839c7d9bfa5, (v) => $707798b68636ebe6$export$cc87a839c7d9bfa5 = v);
$parcel$export($707798b68636ebe6$exports, "iconSetting", () => $707798b68636ebe6$export$874b92ef3aaa4266, (v) => $707798b68636ebe6$export$874b92ef3aaa4266 = v);
$parcel$export($707798b68636ebe6$exports, "iconSettingContainer", () => $707798b68636ebe6$export$2e0589cadb302720, (v) => $707798b68636ebe6$export$2e0589cadb302720 = v);
$parcel$export($707798b68636ebe6$exports, "left_bottom", () => $707798b68636ebe6$export$75782623ade7a3bd, (v) => $707798b68636ebe6$export$75782623ade7a3bd = v);
$parcel$export($707798b68636ebe6$exports, "left_top", () => $707798b68636ebe6$export$85088d7f404e28d9, (v) => $707798b68636ebe6$export$85088d7f404e28d9 = v);
$parcel$export($707798b68636ebe6$exports, "main_hide", () => $707798b68636ebe6$export$1b2bb71fa7c9187f, (v) => $707798b68636ebe6$export$1b2bb71fa7c9187f = v);
$parcel$export($707798b68636ebe6$exports, "main_show", () => $707798b68636ebe6$export$202f1df7e1985b08, (v) => $707798b68636ebe6$export$202f1df7e1985b08 = v);
$parcel$export($707798b68636ebe6$exports, "right_bottom", () => $707798b68636ebe6$export$6e3995c6d9e65dc1, (v) => $707798b68636ebe6$export$6e3995c6d9e65dc1 = v);
$parcel$export($707798b68636ebe6$exports, "right_top", () => $707798b68636ebe6$export$e23bb8cc69092501, (v) => $707798b68636ebe6$export$e23bb8cc69092501 = v);
$parcel$export($707798b68636ebe6$exports, "root", () => $707798b68636ebe6$export$e8e78c978b129247, (v) => $707798b68636ebe6$export$e8e78c978b129247 = v);
$parcel$export($707798b68636ebe6$exports, "scaleUp", () => $707798b68636ebe6$export$114dbff7fb2bf04f, (v) => $707798b68636ebe6$export$114dbff7fb2bf04f = v);
$parcel$export($707798b68636ebe6$exports, "settingText", () => $707798b68636ebe6$export$ad49d1da83f2ed1b, (v) => $707798b68636ebe6$export$ad49d1da83f2ed1b = v);
$parcel$export($707798b68636ebe6$exports, "show", () => $707798b68636ebe6$export$57bf213be019eeb0, (v) => $707798b68636ebe6$export$57bf213be019eeb0 = v);
$parcel$export($707798b68636ebe6$exports, "zoomerContainer", () => $707798b68636ebe6$export$7d5037c0de1f033f, (v) => $707798b68636ebe6$export$7d5037c0de1f033f = v);
var $707798b68636ebe6$export$373e92e0788ff06e;
var $707798b68636ebe6$export$850f7749a2909601;
var $707798b68636ebe6$export$315b15ee15c687e7;
var $707798b68636ebe6$export$c159eaa54b4d0936;
var $707798b68636ebe6$export$28854150e7f765bb;
var $707798b68636ebe6$export$13fb59bcce76d3bb;
var $707798b68636ebe6$export$a3bc9b8ed74fc;
var $707798b68636ebe6$export$6b5cd3983e3ee5ab;
var $707798b68636ebe6$export$87d2c27aff778f15;
var $707798b68636ebe6$export$bb4b59f84891dd48;
var $707798b68636ebe6$export$38e42c68cf43b5d4;
var $707798b68636ebe6$export$e052384d4071fee2;
var $707798b68636ebe6$export$fe8985bb6374093c;
var $707798b68636ebe6$export$fbfa78172a2accb2;
var $707798b68636ebe6$export$cc87a839c7d9bfa5;
var $707798b68636ebe6$export$874b92ef3aaa4266;
var $707798b68636ebe6$export$2e0589cadb302720;
var $707798b68636ebe6$export$75782623ade7a3bd;
var $707798b68636ebe6$export$85088d7f404e28d9;
var $707798b68636ebe6$export$1b2bb71fa7c9187f;
var $707798b68636ebe6$export$202f1df7e1985b08;
var $707798b68636ebe6$export$6e3995c6d9e65dc1;
var $707798b68636ebe6$export$e23bb8cc69092501;
var $707798b68636ebe6$export$e8e78c978b129247;
var $707798b68636ebe6$export$114dbff7fb2bf04f;
var $707798b68636ebe6$export$ad49d1da83f2ed1b;
var $707798b68636ebe6$export$57bf213be019eeb0;
var $707798b68636ebe6$export$7d5037c0de1f033f;
$707798b68636ebe6$export$373e92e0788ff06e = `IZOd5a_LTR`;
$707798b68636ebe6$export$850f7749a2909601 = `IZOd5a_RTL`;
$707798b68636ebe6$export$315b15ee15c687e7 = `IZOd5a_assistant_name`;
$707798b68636ebe6$export$c159eaa54b4d0936 = `IZOd5a_backText`;
$707798b68636ebe6$export$28854150e7f765bb = `IZOd5a_chatbox`;
$707798b68636ebe6$export$13fb59bcce76d3bb = `IZOd5a_chatboxContainer`;
$707798b68636ebe6$export$a3bc9b8ed74fc = `IZOd5a_error`;
$707798b68636ebe6$export$6b5cd3983e3ee5ab = `IZOd5a_float`;
$707798b68636ebe6$export$87d2c27aff778f15 = `IZOd5a_floatAvatar`;
$707798b68636ebe6$export$bb4b59f84891dd48 = `IZOd5a_floatContainer`;
$707798b68636ebe6$export$38e42c68cf43b5d4 = `IZOd5a_header`;
$707798b68636ebe6$export$e052384d4071fee2 = `IZOd5a_headerContainer`;
$707798b68636ebe6$export$fe8985bb6374093c = `IZOd5a_hide`;
$707798b68636ebe6$export$fbfa78172a2accb2 = `IZOd5a_iconBack`;
$707798b68636ebe6$export$cc87a839c7d9bfa5 = `IZOd5a_iconCloseContainer`;
$707798b68636ebe6$export$874b92ef3aaa4266 = `IZOd5a_iconSetting`;
$707798b68636ebe6$export$2e0589cadb302720 = `IZOd5a_iconSettingContainer`;
$707798b68636ebe6$export$75782623ade7a3bd = `IZOd5a_left_bottom`;
$707798b68636ebe6$export$85088d7f404e28d9 = `IZOd5a_left_top`;
$707798b68636ebe6$export$1b2bb71fa7c9187f = `IZOd5a_main_hide`;
$707798b68636ebe6$export$202f1df7e1985b08 = `IZOd5a_main_show`;
$707798b68636ebe6$export$6e3995c6d9e65dc1 = `IZOd5a_right_bottom`;
$707798b68636ebe6$export$e23bb8cc69092501 = `IZOd5a_right_top`;
$707798b68636ebe6$export$e8e78c978b129247 = `IZOd5a_root`;
$707798b68636ebe6$export$114dbff7fb2bf04f = `IZOd5a_scaleUp`;
$707798b68636ebe6$export$ad49d1da83f2ed1b = `IZOd5a_settingText`;
$707798b68636ebe6$export$57bf213be019eeb0 = `IZOd5a_show`;
$707798b68636ebe6$export$7d5037c0de1f033f = `IZOd5a_zoomerContainer`;


const $96750e534f0b3d48$var$DRAWER_MAPPING = (drawerName, props)=>{
    switch(drawerName){
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).drawers.facility:
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $1e6c408e953f9e20$export$2e2bcd8739ae039), {
                ...props
            });
        case (0, $b2e6864aad7029da$export$2e2bcd8739ae039).drawers.settings:
            return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2c618c97a8c42165$export$2e2bcd8739ae039), {
                ...props
            });
        default:
            return null;
    }
};
var $96750e534f0b3d48$export$2e2bcd8739ae039 = ({ className: className, initDataId: initDataId, ...rest })=>{
    const { loaded: loaded, globalErrorMessage: globalErrorMessage, zIndex: zIndex, setShowFacility: setShowFacility, uiDrawer: uiDrawer, setUiDrawer: setUiDrawer, client: client, language: language, languageList: languageList, country: country, countryList: countryList, labels: labels, show: show, setShow: setShow, direction: direction, stage: stage } = (0, $8NFma.useContext)((0, $c1a19c3b921ee155$export$3a739ea0fb83fd37));
    const refChatbox = (0, $8NFma.useRef)(null);
    const scrollBarOffset = (0, $0ea84f440c4091a4$export$2e2bcd8739ae039)();
    const [isDebug, setIsDebug] = (0, $8NFma.useState)(false);
    // ========== configs
    const { theme: theme, display_mode: display_mode = "button_toggle", position: position = "right_bottom", is_click_outside_close: is_click_outside_close = true } = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).get(client, "client_config", {});
    // ========== configs
    (0, $8NFma.useEffect)(()=>{
        if (show && is_click_outside_close) {
            const handleClickOutside = (event)=>{
                if (initDataId && event.target.id === initDataId) return;
                // if click outside of chatbox
                if (refChatbox.current && !refChatbox.current.contains(event.target)) setShow(false);
            };
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [
        show,
        setShow,
        is_click_outside_close
    ]);
    if (!loaded) return null;
    const handleCloseDrawer = ()=>{
        setShowFacility(null);
        setUiDrawer("");
    };
    const jsxError = globalErrorMessage?.chatMessage ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: $707798b68636ebe6$exports.chatbox,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: $707798b68636ebe6$exports.error,
            children: globalErrorMessage?.chatMessage
        })
    }) : null;
    const jsxChatbot = !globalErrorMessage ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.chatbox),
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $70c6311ae6029a37$export$2e2bcd8739ae039), {
                children: uiDrawer ? $96750e534f0b3d48$var$DRAWER_MAPPING(uiDrawer) : null
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $12f3b17fab02290c$export$2e2bcd8739ae039), {})
        ]
    }) : null;
    const jsxDebug = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.chatbox),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("textarea", {
            style: {
                width: "100%",
                height: "100%",
                backgroundColor: "whtie"
            },
            value: JSON.stringify(stage, null, 2),
            disabled: true
        })
    });
    const languageObj = languageList.find((item)=>item.language_code === language);
    const jsxSettings = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.iconSetting),
        onClick: ()=>setUiDrawer((0, $b2e6864aad7029da$export$2e2bcd8739ae039).drawers.settings),
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.iconSettingContainer),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1a831fb0fec97edd$exports)))
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.settingText),
                children: [
                    country || "Country",
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        children: " | "
                    }),
                    languageObj?.native_name || "Language"
                ]
            })
        ]
    });
    const jsxZommers = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.zoomerContainer),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            onClick: ()=>setShow(false),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.iconCloseContainer),
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($96387b9397562cc9$exports)))
            })
        })
    });
    const jsxMain = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("rivara_main", className, $707798b68636ebe6$exports.root, $707798b68636ebe6$exports[position], $707798b68636ebe6$exports[direction], show ? $707798b68636ebe6$exports.main_show : $707798b68636ebe6$exports.main_hide),
        style: {
            zIndex: zIndex + 1,
            ...theme,
            ...scrollBarOffset
        },
        ref: refChatbox,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.header),
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.headerContainer),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            },
                            children: [
                                uiDrawer ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.iconBack),
                                    onClick: handleCloseDrawer,
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($53e85f846a28c66e$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.backText),
                                            children: labels["lbl_Back"] || "BACK"
                                        })
                                    ]
                                }) : jsxSettings,
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                    onClick: ()=>setIsDebug((prev)=>!prev),
                                    children: " Debug "
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            children: !uiDrawer && jsxZommers
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.chatboxContainer),
                children: [
                    jsxError,
                    isDebug ? jsxDebug : jsxChatbot
                ]
            })
        ]
    });
    const clientChatAvatar = client?.client_chat_avatar ? `${client?.client_chat_avatar}?v=${client.updatedAt}` : (0, (/*@__PURE__*/$parcel$interopDefault($0eed5f300391f9fe$exports)));
    const jsxFloat = /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("rivara_float", $707798b68636ebe6$exports.float, $707798b68636ebe6$exports[direction], $707798b68636ebe6$exports[position], show ? $707798b68636ebe6$exports.hide : $707798b68636ebe6$exports.show),
        style: {
            zIndex: zIndex,
            ...theme,
            ...scrollBarOffset
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.floatContainer),
            onClick: ()=>setShow(true),
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.floatAvatar),
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                        src: clientChatAvatar
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))($707798b68636ebe6$exports.assistant_name),
                    children: labels["lbl_YourAssistant"] || "Your Assistant"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
        children: [
            jsxMain,
            display_mode === "float" && jsxFloat
        ]
    });
};


const $be0e007d122132ee$var$RAI = /*#__PURE__*/ (0, $8NFma.forwardRef)(({ initAccessCode: initAccessCode = "", initLanguage: initLanguage = "", initDataId: initDataId = "", initZIndex: initZIndex = "", initUserAvatar: initUserAvatar = "", initCookieOff: initCookieOff = false, initIsPreview: initIsPreview = false, // ==== custom updates from outside ====
languagecode: customLanguage = "", accesscode: customAccessCode = "", useravatar: customUserAvatar = "", ["cookie-off"]: customCookieOff = false, triggerer: // internal use
triggerer = false }, ref)=>{
    const handleClick = ()=>{
        setShow((prev)=>!prev);
    };
    const [show, setShow] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        if (initDataId) {
            const triggerButton = document.querySelector(`#${initDataId}`);
            if (triggerButton) {
                triggerButton.addEventListener("click", handleClick);
                // Cleanup function to remove the event listener
                return ()=>{
                    triggerButton.removeEventListener("click", handleClick);
                };
            }
        }
    }, [
        initDataId
    ]);
    // if no access code, assume its turned off
    // if (!customAccessCode || !initAccessCode) {
    //   return null
    // }
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f8afb0169f3a1369$export$a2d7bc907bed8095), {
        initZIndex: initZIndex,
        initAccessCode: initAccessCode,
        initLanguage: initLanguage,
        initUserAvatar: initUserAvatar,
        initCookieOff: initCookieOff,
        initIsPreview: initIsPreview,
        triggerer: // ==== custom updates from outside ====
        triggerer,
        customLanguage: customLanguage,
        customAccessCode: customAccessCode,
        customUserAvatar: customUserAvatar,
        customCookieOff: customCookieOff,
        show: show,
        setShow: setShow,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $96750e534f0b3d48$export$2e2bcd8739ae039), {
            ref: ref,
            initDataId: initDataId
        })
    });
});
var $be0e007d122132ee$export$2e2bcd8739ae039 = $be0e007d122132ee$var$RAI;


// Access the current script tag
const $933f92cc77282d61$var$currentScript = document.currentScript;
// Read an attribute from the script tag (e.g., data-token)
const $933f92cc77282d61$var$initLanguage = $933f92cc77282d61$var$currentScript.getAttribute("languagecode");
const $933f92cc77282d61$var$initAccessCode = $933f92cc77282d61$var$currentScript.getAttribute("accesscode");
const $933f92cc77282d61$var$initZIndex = $933f92cc77282d61$var$currentScript.getAttribute("z-index");
const $933f92cc77282d61$var$initDataId = $933f92cc77282d61$var$currentScript.getAttribute("trigger-id");
const $933f92cc77282d61$var$initUserAvatar = $933f92cc77282d61$var$currentScript.getAttribute("useravatar");
const $933f92cc77282d61$var$initCookieOff = $933f92cc77282d61$var$currentScript.getAttribute("cookie-off");
const $933f92cc77282d61$var$initIsPreview = $933f92cc77282d61$var$currentScript.getAttribute("preview");
// Function to dynamically load CSS
const $933f92cc77282d61$var$loadCSS = (href)=>{
    if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
    }
};
const $933f92cc77282d61$var$RaiWebComponent = (0, $b51cd1de320412c4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $8NFma.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $be0e007d122132ee$export$2e2bcd8739ae039), {
        ref: ref,
        initLanguage: $933f92cc77282d61$var$initLanguage,
        initAccessCode: $933f92cc77282d61$var$initAccessCode,
        initZIndex: $933f92cc77282d61$var$initZIndex,
        initDataId: $933f92cc77282d61$var$initDataId,
        initUserAvatar: $933f92cc77282d61$var$initUserAvatar,
        initCookieOff: $933f92cc77282d61$var$initCookieOff,
        initIsPreview: $933f92cc77282d61$var$initIsPreview,
        ...props
    });
}), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))), (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))), {
    props: {
        // NOTE: web component only supports lower case
        id: "string",
        // NOTE: dont use language, it is reserved will cause conflict (crush without error message)
        languagecode: "string",
        accesscode: "string",
        ["z-Index"]: "string",
        ["trigger-id"]: "string",
        useravatar: "string",
        ["cookie-off"]: "boolean",
        // internal use
        triggerer: "boolean"
    }
});
class $933f92cc77282d61$var$ExtendedHaiWebComponent extends $933f92cc77282d61$var$RaiWebComponent {
    connectedCallback() {
        super.connectedCallback();
        const scriptUrl = new URL($933f92cc77282d61$var$currentScript.src);
        const cssUrl = new URL("rivara-ai.css", scriptUrl);
        $933f92cc77282d61$var$loadCSS(cssUrl.href);
        // remove styles from the html element rivara-ai
        this.style.display = "";
    }
    update(props) {
        // update attributes of web component
        Object.keys(props).forEach((key)=>{
            this.setAttribute(key, props[key]);
        });
        // update trigger to trigger rerender
        let triggerer = this.getAttribute("triggerer") === "true";
        this.setAttribute("triggerer", !triggerer);
    }
}
customElements.define("rivara-ai", $933f92cc77282d61$var$ExtendedHaiWebComponent);
// if there is no rivara-ai element in the DOM, create one and attach to body
if (!document.querySelector("rivara-ai")) {
    const rai = document.createElement("rivara-ai");
    // default style is display: none
    rai.style.display = "none";
    // append below of script tag
    if ($933f92cc77282d61$var$currentScript && $933f92cc77282d61$var$currentScript.parentNode) $933f92cc77282d61$var$currentScript.parentNode.insertBefore(rai, $933f92cc77282d61$var$currentScript.nextSibling);
    else document.body.appendChild(rai);
}

})();
//# sourceMappingURL=rivara-ai.js.map
